import React, { useEffect, useMemo, useRef, useState } from 'react';
import topCreativeMobileV61 from './assets/tochikatsu-top-creative-mobile-v61.png';

const TOCHIKATSU_UI_VERSION = '6.3.0';

const SERVICE_TERMS_VERSION = '2026-07-19';
const CAMPAIGN_TERMS_VERSION = '2026-07-19';
const PRIVACY_POLICY_URL =
  'https://myhomeheroes-regulation.pages.dev/';
const GENERAL_TERMS_URL =
  'https://myhomeheroes-regulation.pages.dev/terms';

type AgreementModalType =
  | 'serviceTerms'
  | 'campaignTerms';

type AgreementSection = {
  heading: string;
  paragraphs?: string[];
  items?: string[];
};

const SERVICE_TERMS_SECTIONS: AgreementSection[] = [
  {
    heading: '第1条（適用）',
    paragraphs: [
      '本規約は、合同会社Dots（以下「当社」といいます。）が提供する「土地活用WEB診断」（以下「本サービス」といいます。）の利用条件を定めるものです。',
      '本規約は、マイホームヒーローズ利用規約を補足するものです。本サービスに関して両規約の内容が異なる場合は、本規約が優先して適用されます。',
    ],
  },
  {
    heading: '第2条（本サービスの内容）',
    paragraphs: [
      '本サービスは、ユーザーが入力した所在地、物件状態、土地面積、利用目的その他の情報をもとに、土地活用の方向性を簡易的に整理し、候補を表示するサービスです。',
      '本サービスの診断結果は、不動産鑑定、価格査定、収益保証、投資助言、法律相談、税務相談または建築可能性の確定判断ではありません。',
    ],
  },
  {
    heading: '第3条（利用資格・入力情報）',
    items: [
      'ユーザーは、対象不動産の所有者、共有者、または所有者から正当な了承を得た方であるものとします。',
      'ユーザーは、氏名、所有者情報、物件住所、土地面積その他の情報を、真実かつ正確に入力するものとします。',
      '第三者へのなりすまし、無断での第三者情報の入力、虚偽または誤解を招く入力をしてはなりません。',
    ],
  },
  {
    heading: '第4条（診断結果・提案）',
    paragraphs: [
      '診断結果は入力時点の情報に基づく簡易判定であり、法令、権利関係、接道、用途地域、市場状況、建築費その他の事情により、実際に実行できる活用方法と異なる場合があります。',
      '家賃収入、売却価格、税効果その他の経済的成果を保証するものではありません。最終的な判断は、専門家による調査・説明を受けたうえでユーザー自身の責任で行ってください。',
    ],
  },
  {
    heading: '第5条（連絡・外部事業者への紹介）',
    paragraphs: [
      '本診断で取得した連絡先は、本人確認、入力内容の確認、診断結果、特典進呈、重要なお知らせのために利用します。',
      '提携事業者への情報提供、営業提案または個別相談の設定を行う場合は、必要に応じて別途ユーザーの同意を取得します。',
    ],
  },
  {
    heading: '第6条（禁止事項）',
    items: [
      '法令または公序良俗に反する行為',
      '虚偽入力、重複申込み、特典の不正取得を目的とする行為',
      '本サービスのシステムに過度な負荷をかける行為',
      '本サービスの運営を妨害し、または第三者の権利を侵害する行為',
      '自動化ツール、ボットその他の不正な手段を用いる行為',
    ],
  },
  {
    heading: '第7条（利用料金）',
    paragraphs: [
      '本サービスの利用料金は無料です。ただし、通信費、端末費用その他の利用環境に関する費用はユーザーの負担となります。',
    ],
  },
  {
    heading: '第8条（サービスの変更・中断）',
    paragraphs: [
      '当社は、保守、障害、法令対応、天災その他やむを得ない事情がある場合、本サービスの全部または一部を変更、中断または終了できるものとします。',
    ],
  },
  {
    heading: '第9条（免責・責任の範囲）',
    paragraphs: [
      '当社は、診断結果の完全性、正確性、有用性、特定目的への適合性を保証しません。',
      '当社の故意または重過失による場合を除き、本サービスの利用により生じた間接損害、特別損害、逸失利益について責任を負いません。',
    ],
  },
  {
    heading: '第10条（個人情報）',
    paragraphs: [
      '個人情報の取扱いは、当社が別途定める「個人情報のお取扱いについて」に従います。',
    ],
  },
  {
    heading: '第11条（規約の変更）',
    paragraphs: [
      '当社は、法令改正、サービス内容の変更その他合理的な必要がある場合、本規約を変更できます。重要な変更は、本サービス上その他適切な方法で告知します。',
    ],
  },
  {
    heading: '第12条（準拠法・管轄）',
    paragraphs: [
      '本規約は日本法に準拠します。本サービスに関する紛争は、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。',
    ],
  },
];

const CAMPAIGN_TERMS_SECTIONS: AgreementSection[] = [
  {
    heading: '第1条（キャンペーンの名称・主催者）',
    paragraphs: [
      '本キャンペーンの名称は「土地活用WEB診断 Amazonギフトカード3,000円分進呈キャンペーン」とします。',
      '本キャンペーンの主催者は合同会社Dotsです。',
    ],
  },
  {
    heading: '第2条（実施期間）',
    paragraphs: [
      '本キャンペーンは、本診断ページまたは案内媒体に「キャンペーン実施中」と表示されている期間に実施します。終了する場合は、本診断ページまたは案内媒体で告知します。',
    ],
  },
  {
    heading: '第3条（対象者）',
    items: [
      '日本国内に居住する18歳以上の方',
      '対象不動産の所有者、共有者、または所有者から正当な了承を得た方',
      '診断質問、物件情報、所有者情報および本人情報を正確に入力した方',
      '有効なメールアドレスまたはSMSを受信できる携帯電話番号を登録した方',
    ],
  },
  {
    heading: '第4条（対象となる不動産）',
    paragraphs: [
      '対象となる不動産は、日本国内に所在し、当社が本診断および活用検討の対象として確認できる土地、空き家、一棟建物その他の不動産です。',
      '次の不動産は原則として対象外です。',
    ],
    items: [
      '現在、申込者本人が自己使用し、居住している土地・建物',
      '区分マンション',
      '山林、農地、その他著しく活用の困難な地域にある土地（当社の判断）',
      '正確な所在地、所有者または権利関係を確認できない不動産',
    ],
  },
  {
    heading: '第5条（特典対象条件）',
    items: [
      '本診断を最後まで完了していること',
      '正確な物件住所、物件情報および所有者情報が入力されていること',
      '入力した所有者情報と当社が確認できる本人・所有関係が一致していること',
      '弊社からの本人確認のご連絡に対し、メールまたは電話等でご返答いただき、確認が取れること',
      '利用規約、キャンペーン規約および個人情報のお取扱いに同意していること',
      '本規約に定める対象外事由に該当しないこと',
    ],
  },
  {
    heading: '第6条（特典の内容・進呈時期）',
    paragraphs: [
      '対象条件をすべて満たした方に、Amazonギフトカード3,000円分を進呈します。',
      '特典は、ご本人確認後、登録されたメールアドレスまたはSMS宛てに送付します。',
      '対象外となった場合は、確認結果および主な理由を登録された連絡先へお知らせします。',
    ],
  },
  {
    heading: '第7条（申込み回数・重複）',
    paragraphs: [
      '特典の進呈は、キャンペーン期間中、原則として同一人物・同一世帯・同一不動産につき1回限りです。',
      '氏名、住所、連絡先、端末情報その他の情報から重複申込みと合理的に判断できる場合、当社は対象外とすることがあります。',
    ],
  },
  {
    heading: '第8条（対象外・取消し）',
    items: [
      '虚偽、不正確または他人名義の情報が入力された場合',
      '本人確認または所有関係を確認できない場合',
      '特典のみを目的とした不正申込み、重複申込み、自動化された申込みと判断した場合',
      '登録されたメールアドレスまたは電話番号が無効で、連絡・送付ができない場合',
      '本規約または利用規約に違反した場合',
      'その他、当社が不正利用防止のため合理的に対象外と判断した場合',
    ],
  },
  {
    heading: '第9条（特典の受領）',
    paragraphs: [
      '特典の換金、交換、譲渡、転売または名義変更はできません。',
      '申込者の入力誤り、受信拒否設定、メールボックス容量超過、電話番号変更その他申込者側の事情により受領できない場合、当社は再送できないことがあります。',
      '当社の送付処理上の誤りが確認された場合は、合理的な範囲で再送等の対応を行います。',
    ],
  },
  {
    heading: '第10条（変更・中止）',
    paragraphs: [
      '当社は、システム障害、法令対応、天災その他やむを得ない事情がある場合、本キャンペーンの内容を変更または中止できます。',
      '既に対象条件を満たした方に不利益となる変更は、やむを得ない場合を除き行いません。',
    ],
  },
  {
    heading: '第11条（個人情報）',
    paragraphs: [
      '応募情報は、本人確認、対象条件確認、不正防止、特典送付、問い合わせ対応および本キャンペーンの運営に使用します。',
      '詳細は「個人情報のお取扱いについて」をご確認ください。',
    ],
  },
  {
    heading: '第12条（Amazonに関する表示）',
    paragraphs: [
      'Amazonギフトカードの利用には、Amazonギフトカードに関する条件が適用されます。',
      '本キャンペーンは合同会社Dotsが独自に実施するものであり、Amazon.co.jp、Amazon.com, Inc.またはその関連会社による提供、協賛、運営ではありません。',
      'Amazon、Amazon.co.jpおよびそれらのロゴは、Amazon.com, Inc.またはその関連会社の商標です。',
    ],
  },
  {
    heading: '第13条（お問い合わせ・準拠法）',
    paragraphs: [
      'お問い合わせ先：合同会社Dots　myhomeheroes.noreply@dots-cnct.com',
      '本規約は日本法に準拠し、本キャンペーンに関する紛争は、東京地方裁判所または東京簡易裁判所を第一審の専属的合意管轄裁判所とします。',
    ],
  },
];

export type MainRoute =
  | 'build'
  | 'sell'
  | 'lowCost'
  | 'dispose'
  | 'reposition'
  | 'selfUse';

export type BuildSubtype =
  | 'apartment'
  | 'rentalHouse'
  | 'mixedUseHouse'
  | 'twoFamilyHouse';

export type AreaTier =
  | 'metroCandidate'
  | 'regionalCore'
  | 'specialMarket'
  | 'local';

export type EffectiveLocation =
  | 'urbanStrong'
  | 'urbanModerate'
  | 'suburban'
  | 'rural';

export type PropertyType =
  | 'empty_house'
  | 'vacant_land'
  | 'parking'
  | 'whole_rental'
  | 'self_use'
  | 'farmland'
  | 'forest'
  | 'other';

export type StationDistance =
  | 'within_5_minutes'
  | 'within_10_minutes'
  | 'within_20_minutes'
  | 'over_20_minutes'
  | 'car_centered'
  | 'far_from_city'
  | 'unknown';

export type LandArea =
  | 'under_30'
  | '30_49'
  | '50_79'
  | '80_149'
  | 'over_150'
  | 'unknown';

export type ResidencePlan =
  | 'none'
  | 'self_household'
  | 'two_generation'
  | 'family_only'
  | 'undecided';

export type HousingStatus =
  | 'own_home'
  | 'rental_home'
  | 'family_home'
  | 'company_housing'
  | 'other_unknown';

export type Priority =
  | 'rental_income'
  | 'sell'
  | 'low_initial_cost'
  | 'self_use'
  | 'end_ownership'
  | 'undecided';

export type Concern =
  | 'tax_burden'
  | 'maintenance_cost'
  | 'aging_building'
  | 'inheritance'
  | 'failed_sale'
  | 'vacancy'
  | 'leasehold_dispute'
  | 'coownership_problem'
  | 'none';

export type DiagnosisAnswers = {
  prefecture?: string;
  propertyType?: PropertyType;
  stationDistance?: StationDistance;
  landArea?: LandArea;
  residencePlan?: ResidencePlan;
  currentHousing?: HousingStatus;
  priority?: Priority;
  concerns: Concern[];
};

type MainScores = Record<MainRoute, number>;
type BuildScores = Record<BuildSubtype, number>;

export type DiagnosisCandidate = {
  key: string;
  route: MainRoute;
  subtype?: BuildSubtype;
  label: string;
  score: number;
  description: string;
};

export type DiagnosisResult = {
  primary: DiagnosisCandidate;
  secondary: DiagnosisCandidate | null;
  tertiary: DiagnosisCandidate | null;
  reasons: string[];
  conditions: string[];
  warnings: string[];
  areaTier: AreaTier;
  effectiveLocation: EffectiveLocation;
  campaignEligible: boolean;
  flags: DiagnosisFlags;
  scores: {
    main: MainScores;
    build: BuildScores;
  };
};

export type DiagnosisFlags = {
  landAreaAtLeast30: boolean;
  landAreaAtLeast50: boolean;
  hasRentalIncomeIntent: boolean;
  hasRightsIssue: boolean;
  isSpecialLand: boolean;
  hasVacancyProblem: boolean;
  hasExistingRentalBuilding: boolean;
  mixedUseEligible: boolean;
  mixedUseStrong: boolean;
  twoFamilyEligible: boolean;
  rentalBuildEligible: boolean;
  regionalBuildGatePassed: boolean;
  specialMarketBuildGatePassed: boolean;
  shouldPrioritizeDisposal: boolean;
};

type Stage =
  | 'intro'
  | 'questions'
  | 'result'
  | 'form'
  | 'submitting'
  | 'done';

type LeadForm = {
  applicantName: string;
  ownerRelationship: string;
  ownerName: string;
  zip: string;
  cityTown: string;
  street: string;
  email: string;
  phone: string;
  privacyAccepted: boolean;
};

type PostalLookupStatus = 'idle' | 'loading' | 'success' | 'error';

type PostalAddress = {
  prefecture: string;
  city: string;
  town: string;
};

type ZipCloudResponse = {
  status: number;
  message: string | null;
  results:
    | Array<{
        address1: string;
        address2: string;
        address3: string;
        zipcode: string;
      }>
    | null;
};

type Props = {
  submitEndpoint?: string;
  previewMode?: boolean;
  lineBuildUrl?: string;
  lineSellUrl?: string;
  lineRightsUrl?: string;

  /**
   * トップクリエイティブの縮尺です。
   * 1 = 100%、0.95 = 95%、0.9 = 90%
   * 0.7〜1の範囲に自動補正されます。
   */
  heroScale?: number;

  onTrack?: (event: string, payload?: Record<string, unknown>) => void;
};

const PREFECTURES = [
  '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
  '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
  '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県',
  '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県',
  '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県',
  '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県',
  '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県',
] as const;

const PREFECTURE_GROUPS = [
  {
    id: 'tokyo_area',
    label: '東京・神奈川・千葉・埼玉',
    prefectures: ['東京都', '神奈川県', '千葉県', '埼玉県'],
  },
  {
    id: 'kansai_chubu',
    label: '大阪・京都・兵庫・愛知',
    prefectures: ['大阪府', '京都府', '兵庫県', '愛知県'],
  },
  {
    id: 'fukuoka',
    label: '福岡',
    prefectures: ['福岡県'],
  },
  {
    id: 'regional_core',
    label: '北海道・宮城・新潟・静岡・岡山・広島・熊本',
    prefectures: ['北海道', '宮城県', '新潟県', '静岡県', '岡山県', '広島県', '熊本県'],
  },
  {
    id: 'okinawa',
    label: '沖縄',
    prefectures: ['沖縄県'],
  },
  {
    id: 'other',
    label: 'その他の地域',
    prefectures: PREFECTURES.filter(
      (prefecture) =>
        ![
          '東京都', '神奈川県', '千葉県', '埼玉県',
          '大阪府', '京都府', '兵庫県', '愛知県',
          '福岡県', '北海道', '宮城県', '新潟県',
          '静岡県', '岡山県', '広島県', '熊本県', '沖縄県',
        ].includes(prefecture),
    ),
  },
] as const;

export const METRO_PREFECTURES = new Set([
  '東京都', '神奈川県', '千葉県', '埼玉県',
  '大阪府', '京都府', '兵庫県', '愛知県', '福岡県',
]);

export const REGIONAL_CORE_PREFECTURES = new Set([
  '北海道', '宮城県', '新潟県', '静岡県',
  '岡山県', '広島県', '熊本県',
]);

export const SPECIAL_MARKET_PREFECTURES = new Set(['沖縄県']);

export const MIXED_USE_ALLOWED_PREFECTURES = new Set([
  '東京都', '神奈川県', '千葉県', '埼玉県',
  '大阪府', '愛知県', '福岡県',
]);

const MAIN_ROUTE_LABELS: Record<MainRoute, string> = {
  build: '建てて収益化',
  sell: '売却して現金化',
  lowCost: '駐車場など低負担で活用',
  dispose: '費用負担を含めて保有を終了',
  reposition: '空室改善・建て替え・運用見直し',
  selfUse: '自分または家族で使用',
};

const BUILD_LABELS: Record<BuildSubtype, string> = {
  apartment: '賃貸アパート',
  rentalHouse: '賃貸戸建て',
  mixedUseHouse: '賃貸併用住宅',
  twoFamilyHouse: '二世帯住宅',
};

const ROUTE_DESCRIPTIONS: Record<MainRoute, string> = {
  build: '立地・広さ・居住予定を踏まえて、建築による活用可能性を比較します。',
  sell: '保有負担を止め、土地や建物を現金化する方向性です。',
  lowCost: '大きな初期投資を抑え、駐車場などで活用する方向性です。',
  dispose: '通常売却だけでなく、費用負担を含む手放し方も確認します。',
  reposition: '既存賃貸物件の空室改善、運用変更、建て替えを比較します。',
  selfUse: 'ご本人またはご家族の住まいとして利用する方向性です。',
};

function emptyMainScores(): MainScores {
  return {
    build: 0,
    sell: 0,
    lowCost: 0,
    dispose: 0,
    reposition: 0,
    selfUse: 0,
  };
}

function emptyBuildScores(): BuildScores {
  return {
    apartment: 0,
    rentalHouse: 0,
    mixedUseHouse: 0,
    twoFamilyHouse: 0,
  };
}

export function getAreaTier(prefecture: string): AreaTier {
  if (METRO_PREFECTURES.has(prefecture)) return 'metroCandidate';
  if (REGIONAL_CORE_PREFECTURES.has(prefecture)) return 'regionalCore';
  if (SPECIAL_MARKET_PREFECTURES.has(prefecture)) return 'specialMarket';
  return 'local';
}

function isAtLeast30(area: LandArea): boolean {
  return ['30_49', '50_79', '80_149', 'over_150'].includes(area);
}

function isAtLeast50(area: LandArea): boolean {
  return ['50_79', '80_149', 'over_150'].includes(area);
}

function needsHousingQuestion(plan?: ResidencePlan): boolean {
  return plan === 'self_household' || plan === 'two_generation';
}

export function getEffectiveLocation(
  areaTier: AreaTier,
  stationDistance: StationDistance,
  landArea: LandArea,
): EffectiveLocation {
  const atLeast50 = isAtLeast50(landArea);

  if (areaTier === 'metroCandidate') {
    if (
      stationDistance === 'within_5_minutes' ||
      stationDistance === 'within_10_minutes'
    ) return 'urbanStrong';

    if (stationDistance === 'within_20_minutes') {
      return 'urbanModerate';
    }

    return 'suburban';
  }

  if (areaTier === 'regionalCore') {
    if (stationDistance === 'within_5_minutes') {
      return atLeast50 ? 'urbanStrong' : 'urbanModerate';
    }
    if (stationDistance === 'within_10_minutes') return 'urbanModerate';
    if (
      stationDistance === 'within_20_minutes' ||
      stationDistance === 'over_20_minutes'
    ) return 'suburban';
    if (
      stationDistance === 'car_centered' ||
      stationDistance === 'far_from_city'
    ) return 'rural';

    return 'suburban';
  }

  if (areaTier === 'specialMarket') {
    if (stationDistance === 'within_5_minutes') {
      return atLeast50 ? 'urbanStrong' : 'urbanModerate';
    }
    if (
      stationDistance === 'far_from_city' ||
      stationDistance === 'over_20_minutes'
    ) return 'rural';

    return 'suburban';
  }

  if (
    stationDistance === 'within_5_minutes' ||
    stationDistance === 'within_10_minutes'
  ) return 'urbanModerate';

  if (stationDistance === 'within_20_minutes') return 'suburban';
  return 'rural';
}

function stationBuildAdjustment(distance: StationDistance): number {
  switch (distance) {
    case 'within_5_minutes':
      return 8;
    case 'within_10_minutes':
      return 5;
    case 'within_20_minutes':
      return 2;
    case 'over_20_minutes':
      return -3;
    case 'car_centered':
    case 'far_from_city':
      return -5;
    default:
      return 0;
  }
}

function applyAreaBuildScores(scores: BuildScores, area: LandArea): void {
  switch (area) {
    case 'under_30':
      scores.rentalHouse += 2;
      break;
    case '30_49':
      scores.rentalHouse += 10;
      scores.apartment += 5;
      break;
    case '50_79':
      scores.rentalHouse += 8;
      scores.apartment += 10;
      break;
    case '80_149':
      scores.rentalHouse += 5;
      scores.apartment += 14;
      break;
    case 'over_150':
      scores.rentalHouse += 4;
      scores.apartment += 14;
      break;
  }
}

function applyBaseScores(
  input: Required<DiagnosisAnswers>,
  main: MainScores,
  build: BuildScores,
  effectiveLocation: EffectiveLocation,
): void {
  switch (input.propertyType) {
    case 'empty_house':
      main.build += 6;
      main.sell += 8;
      main.dispose += 3;
      break;
    case 'vacant_land':
      main.build += 8;
      main.sell += 4;
      main.lowCost += 8;
      break;
    case 'parking':
      main.lowCost += 15;
      main.build += 3;
      break;
    case 'whole_rental':
      main.reposition += 8;
      main.sell += 5;
      main.build += 4;
      break;
    case 'self_use':
      main.selfUse += 15;
      break;
    case 'other':
      main.sell += 3;
      main.lowCost += 3;
      break;
  }

  switch (input.residencePlan) {
    case 'none':
      main.sell += 4;
      main.lowCost += 4;
      break;
    case 'self_household':
      main.selfUse += 18;
      main.build += 10;
      break;
    case 'two_generation':
      main.selfUse += 12;
      main.build += 15;
      break;
    case 'family_only':
      main.selfUse += 22;
      break;
    case 'undecided':
      main.sell += 3;
      main.lowCost += 3;
      main.selfUse += 2;
      break;
  }

  switch (input.priority) {
    case 'rental_income':
      main.build += 24;
      break;
    case 'sell':
      main.sell += 25;
      break;
    case 'low_initial_cost':
      main.lowCost += 22;
      break;
    case 'self_use':
      main.selfUse += 25;
      break;
    case 'end_ownership':
      main.dispose += 25;
      main.sell += 10;
      break;
    case 'undecided':
      main.build += 5;
      main.sell += 5;
      main.lowCost += 5;
      main.selfUse += 5;
      break;
  }

  if (input.concerns.includes('tax_burden')) {
    main.build += 5;
    main.sell += 4;
    main.lowCost += 4;
    main.dispose += 4;
  }
  if (input.concerns.includes('maintenance_cost')) {
    main.sell += 7;
    main.dispose += 7;
  }
  if (input.concerns.includes('aging_building')) {
    main.sell += 8;
    main.reposition += 8;
    main.build += 3;
  }
  if (input.concerns.includes('inheritance')) {
    main.sell += 7;
  }
  if (input.concerns.includes('failed_sale')) {
    main.sell -= 5;
    main.dispose += 10;
  }
  if (
    input.concerns.includes('vacancy') &&
    input.propertyType === 'whole_rental'
  ) {
    main.reposition += 25;
    main.sell += 8;
    main.build += 5;
  }

  switch (effectiveLocation) {
    case 'urbanStrong':
      main.build += 8;
      main.sell += 4;
      main.lowCost += 3;
      break;
    case 'urbanModerate':
      main.build += 4;
      main.sell += 4;
      main.lowCost += 4;
      break;
    case 'suburban':
      main.sell += 7;
      main.lowCost += 7;
      main.dispose += 3;
      break;
    case 'rural':
      main.sell += 7;
      main.lowCost += 3;
      main.dispose += 8;
      break;
  }

  applyAreaBuildScores(build, input.landArea);
}

function buildCandidate(
  subtype: BuildSubtype,
  main: MainScores,
  build: BuildScores,
): DiagnosisCandidate {
  return {
    key: `build:${subtype}`,
    route: 'build',
    subtype,
    label: BUILD_LABELS[subtype],
    score: main.build + build[subtype],
    description: ROUTE_DESCRIPTIONS.build,
  };
}

function routeCandidate(
  route: Exclude<MainRoute, 'build'>,
  main: MainScores,
): DiagnosisCandidate {
  return {
    key: route,
    route,
    label: MAIN_ROUTE_LABELS[route],
    score: main[route],
    description: ROUTE_DESCRIPTIONS[route],
  };
}

function rankedCandidates(
  main: MainScores,
  build: BuildScores,
  isSpecialLand: boolean,
): DiagnosisCandidate[] {
  const buildOrder: BuildSubtype[] = [
    'apartment',
    'rentalHouse',
    'mixedUseHouse',
    'twoFamilyHouse',
  ];

  const buildCandidates = isSpecialLand
    ? []
    : buildOrder
        .filter((subtype) => build[subtype] > 0)
        .map((subtype) => buildCandidate(subtype, main, build));

  const otherRoutes: Array<Exclude<MainRoute, 'build'>> = [
    'sell',
    'lowCost',
    'dispose',
    'reposition',
    'selfUse',
  ];

  return [
    ...buildCandidates,
    ...otherRoutes
      .filter((route) => main[route] > 0)
      .map((route) => routeCandidate(route, main)),
  ].sort((left, right) => right.score - left.score);
}

function uniqueCandidates(candidates: DiagnosisCandidate[]): DiagnosisCandidate[] {
  const seen = new Set<string>();

  return candidates.filter((candidate) => {
    if (seen.has(candidate.key)) return false;
    seen.add(candidate.key);
    return true;
  });
}

function prioritize(
  candidates: DiagnosisCandidate[],
  predicates: Array<(candidate: DiagnosisCandidate) => boolean>,
): DiagnosisCandidate[] {
  const prioritized: DiagnosisCandidate[] = [];
  const remaining = [...candidates];

  predicates.forEach((predicate) => {
    const index = remaining.findIndex(predicate);
    if (index >= 0) {
      const [candidate] = remaining.splice(index, 1);
      prioritized.push(candidate);
    }
  });

  return uniqueCandidates([...prioritized, ...remaining]);
}

function createReasons(
  input: Required<DiagnosisAnswers>,
  flags: DiagnosisFlags,
  result: DiagnosisCandidate,
): string[] {
  const reasons: string[] = [];

  if (flags.isSpecialLand) {
    reasons.push(
      '畑・農地・山林は、建築活用ではなく売却または保有終了を優先しています。',
    );
    if (flags.shouldPrioritizeDisposal) {
      reasons.push(
        '維持負担・利用予定・立地条件から、通常売却以外の手放し方も比較対象です。',
      );
    }
  } else {
    if (result.route === 'build') {
      if (flags.rentalBuildEligible) {
        reasons.push(
          'エリア・駅距離・土地面積が賃貸建築の優先条件に合っています。',
        );
      } else {
        reasons.push(
          '土地の広さ、居住予定、収益意向から建築可能性を判定しています。',
        );
      }

      if (result.subtype === 'mixedUseHouse') {
        reasons.push(
          input.currentHousing === 'own_home'
            ? '現在は持ち家のため、住み替え条件を確認したうえで賃貸併用住宅を比較します。'
            : '現在の住まいと、ご自身も住みながら家賃収入を得たい希望を反映しています。',
        );
      } else if (result.subtype === 'twoFamilyHouse') {
        reasons.push(
          '親世帯・子世帯で住む予定を、駅距離より優先して反映しています。',
        );
      } else if (result.subtype === 'apartment') {
        reasons.push(
          '土地面積から、賃貸戸建てよりアパートの比較優先度が高い判定です。',
        );
      } else if (result.subtype === 'rentalHouse') {
        reasons.push(
          '土地面積から、小規模でも検討しやすい賃貸戸建てを優先しています。',
        );
      }
    }

    if (result.route === 'reposition') {
      reasons.push(
        '既存賃貸物件の空室が目立つため、新規建築より運用改善を先に判定しています。',
      );
    }
    if (result.route === 'sell') {
      reasons.push(
        '現金化の希望、保有負担、立地条件を総合して売却を優先しています。',
      );
    }
    if (result.route === 'lowCost') {
      reasons.push(
        '初期費用を抑えたい希望と立地条件から、低負担活用を優先しています。',
      );
    }
    if (result.route === 'selfUse') {
      reasons.push(
        '誰が住む予定かと現在の住まいの状況を反映しています。',
      );
    }
  }

  reasons.push(
    `${input.prefecture}のエリア区分と交通利便性を簡易判定に反映しています。`,
  );

  return reasons.slice(0, 3);
}

export function diagnoseLandUse(
  answers: DiagnosisAnswers,
): DiagnosisResult | null {
  const housingRequired = needsHousingQuestion(answers.residencePlan);
  const required = [
    answers.prefecture,
    answers.propertyType,
    answers.stationDistance,
    answers.landArea,
    answers.residencePlan,
    answers.priority,
    housingRequired ? answers.currentHousing : 'not_required',
  ];

  if (required.some((value) => !value) || answers.concerns.length === 0) {
    return null;
  }

  const input = {
    ...answers,
    currentHousing: answers.currentHousing ?? 'other_unknown',
  } as Required<DiagnosisAnswers>;

  const areaTier = getAreaTier(input.prefecture);
  const effectiveLocation = getEffectiveLocation(
    areaTier,
    input.stationDistance,
    input.landArea,
  );

  const landAreaAtLeast30 = isAtLeast30(input.landArea);
  const landAreaAtLeast50 = isAtLeast50(input.landArea);
  const hasRentalIncomeIntent = input.priority === 'rental_income';
  const hasRightsIssue =
    input.concerns.includes('leasehold_dispute') ||
    input.concerns.includes('coownership_problem');
  const isSpecialLand =
    input.propertyType === 'farmland' ||
    input.propertyType === 'forest';
  const hasVacancyProblem = input.concerns.includes('vacancy');
  const hasExistingRentalBuilding = input.propertyType === 'whole_rental';

  const regionalBuildGatePassed =
    areaTier === 'regionalCore' &&
    input.stationDistance === 'within_5_minutes' &&
    landAreaAtLeast50;

  const specialMarketBuildGatePassed =
    areaTier === 'specialMarket' &&
    input.stationDistance === 'within_5_minutes' &&
    landAreaAtLeast50;

  const metroRentalBuildEligible =
    areaTier === 'metroCandidate' &&
    landAreaAtLeast30 &&
    input.residencePlan === 'none' &&
    hasRentalIncomeIntent;

  const regionalCoreRentalBuildEligible =
    regionalBuildGatePassed &&
    input.residencePlan === 'none' &&
    hasRentalIncomeIntent;

  const specialMarketRentalBuildEligible =
    specialMarketBuildGatePassed &&
    input.residencePlan === 'none' &&
    hasRentalIncomeIntent;

  const rentalBuildEligible =
    metroRentalBuildEligible ||
    regionalCoreRentalBuildEligible ||
    specialMarketRentalBuildEligible;

  const mixedUseEligible =
    MIXED_USE_ALLOWED_PREFECTURES.has(input.prefecture) &&
    landAreaAtLeast30 &&
    input.residencePlan === 'self_household' &&
    hasRentalIncomeIntent;

  const mixedUseStrong =
    mixedUseEligible &&
    input.currentHousing !== 'own_home';

  const twoFamilyEligible =
    landAreaAtLeast30 &&
    input.residencePlan === 'two_generation';

  const disposalSignals = [
    effectiveLocation === 'rural',
    input.concerns.includes('tax_burden'),
    input.concerns.includes('maintenance_cost'),
    input.concerns.includes('failed_sale'),
    input.residencePlan === 'none',
    input.priority === 'end_ownership',
  ].filter(Boolean).length;

  const shouldPrioritizeDisposal =
    isSpecialLand &&
    (
      disposalSignals >= 3 ||
      (
        effectiveLocation === 'rural' &&
        input.residencePlan === 'none' &&
        (
          input.concerns.includes('maintenance_cost') ||
          input.concerns.includes('failed_sale')
        )
      )
    );

  const flags: DiagnosisFlags = {
    landAreaAtLeast30,
    landAreaAtLeast50,
    hasRentalIncomeIntent,
    hasRightsIssue,
    isSpecialLand,
    hasVacancyProblem,
    hasExistingRentalBuilding,
    mixedUseEligible,
    mixedUseStrong,
    twoFamilyEligible,
    rentalBuildEligible,
    regionalBuildGatePassed,
    specialMarketBuildGatePassed,
    shouldPrioritizeDisposal,
  };

  const main = emptyMainScores();
  const build = emptyBuildScores();

  applyBaseScores(input, main, build, effectiveLocation);

  if (rentalBuildEligible) {
    main.build += 18;
    main.sell += 5;
    build.apartment += 10;
    build.rentalHouse += 10;

    if (areaTier === 'metroCandidate') {
      const adjustment = stationBuildAdjustment(input.stationDistance);
      main.build += adjustment;
      build.apartment += adjustment;
      build.rentalHouse += adjustment;
    }
  } else if (
    areaTier === 'regionalCore' &&
    input.stationDistance === 'within_5_minutes' &&
    input.landArea === '30_49' &&
    hasRentalIncomeIntent &&
    input.residencePlan === 'none'
  ) {
    main.build += 6;
    main.sell += 12;
    main.lowCost += 4;
    build.rentalHouse += 10;
    build.apartment = -100;
  } else if (
    (areaTier === 'regionalCore' || areaTier === 'specialMarket') &&
    hasRentalIncomeIntent &&
    input.residencePlan === 'none'
  ) {
    main.build -= 35;
    main.sell += 12;
    main.lowCost += 10;
  } else if (
    areaTier === 'local' &&
    hasRentalIncomeIntent &&
    input.residencePlan === 'none' &&
    (
      effectiveLocation === 'suburban' ||
      effectiveLocation === 'rural'
    )
  ) {
    main.build -= 20;
    main.sell += 8;
    main.lowCost += 8;
  }

  if (mixedUseEligible) {
    main.build += 20;
    build.mixedUseHouse += 20;

    if (landAreaAtLeast50) {
      build.mixedUseHouse += 5;
    }

    if (
      input.stationDistance === 'within_5_minutes' ||
      input.stationDistance === 'within_10_minutes'
    ) {
      build.mixedUseHouse += 5;
    }

    switch (input.currentHousing) {
      case 'rental_home':
      case 'family_home':
        build.mixedUseHouse += 8;
        break;
      case 'company_housing':
        build.mixedUseHouse += 6;
        break;
      case 'own_home':
        build.mixedUseHouse -= 5;
        build.apartment += 5;
        build.rentalHouse += 3;
        break;
      default:
        build.mixedUseHouse += 3;
        break;
    }
  }

  if (twoFamilyEligible) {
    main.build += 20;
    build.twoFamilyHouse += 24;

    if (landAreaAtLeast50) {
      build.twoFamilyHouse += 8;
    }

    if (input.currentHousing === 'own_home') {
      build.twoFamilyHouse += 2;
    }
  }

  if (
    input.residencePlan === 'family_only' &&
    input.priority !== 'rental_income'
  ) {
    main.selfUse += 12;
  }

  if (hasRightsIssue) {
    main.build -= 10;
    main.lowCost -= 6;
    main.sell += 2;
  }

  if (isSpecialLand) {
    build.apartment -= 100;
    build.rentalHouse -= 100;
    build.mixedUseHouse -= 100;
    build.twoFamilyHouse -= 100;
    main.build -= 100;
    main.lowCost -= 30;
    main.selfUse -= 20;
    main.reposition -= 20;
    main.sell += 20;
    main.dispose += 15;
  }

  let candidates = rankedCandidates(main, build, isSpecialLand);

  if (isSpecialLand) {
    candidates = candidates.filter(
      (candidate) =>
        candidate.route === 'sell' ||
        candidate.route === 'dispose',
    );

    candidates = prioritize(candidates, [
      (candidate) =>
        candidate.route === (
          shouldPrioritizeDisposal ? 'dispose' : 'sell'
        ),
    ]);
  } else if (
    hasVacancyProblem &&
    hasExistingRentalBuilding
  ) {
    candidates = prioritize(candidates, [
      (candidate) => candidate.route === 'reposition',
      (candidate) => candidate.route === 'sell',
      (candidate) => candidate.route === 'build',
    ]);
  } else if (twoFamilyEligible) {
    candidates = prioritize(candidates, [
      (candidate) =>
        candidate.route === 'build' &&
        candidate.subtype === 'twoFamilyHouse',
      (candidate) => candidate.route === 'selfUse',
      (candidate) => candidate.route === 'sell',
    ]);
  } else if (mixedUseStrong) {
    candidates = prioritize(candidates, [
      (candidate) =>
        candidate.route === 'build' &&
        candidate.subtype === 'mixedUseHouse',
      (candidate) =>
        candidate.route === 'build' &&
        candidate.subtype === 'rentalHouse',
      (candidate) => candidate.route === 'selfUse',
    ]);
  } else if (
    areaTier === 'regionalCore' &&
    input.stationDistance === 'within_5_minutes' &&
    input.landArea === '30_49' &&
    hasRentalIncomeIntent &&
    input.residencePlan === 'none'
  ) {
    candidates = prioritize(candidates, [
      (candidate) =>
        candidate.route === 'build' &&
        candidate.subtype === 'rentalHouse',
      (candidate) => candidate.route === 'sell',
      (candidate) => candidate.route === 'lowCost',
    ]);
  } else if (
    (areaTier === 'regionalCore' || areaTier === 'specialMarket') &&
    hasRentalIncomeIntent &&
    input.residencePlan === 'none' &&
    !rentalBuildEligible
  ) {
    candidates = prioritize(candidates, [
      (candidate) => candidate.route === 'sell',
      (candidate) => candidate.route === 'lowCost',
      (candidate) => candidate.route === 'build',
    ]);
  }

  if (candidates.length === 0) {
    candidates = [
      routeCandidate('sell', {
        ...main,
        sell: 1,
      }),
    ];
  }

  const primary = candidates[0];
  const secondary = candidates[1] ?? null;
  const tertiary = candidates[2] ?? null;

  const conditions: string[] = [];
  const warnings: string[] = [];

  if (input.concerns.includes('leasehold_dispute')) {
    conditions.push(
      '借地権・底地権の整理後に、表示された活用方法を具体化する必要があります。',
    );
  }
  if (input.concerns.includes('coownership_problem')) {
    conditions.push(
      '共有者間の合意形成後に、表示された活用方法を具体化する必要があります。',
    );
  }
  if (
    input.concerns.includes('vacancy') &&
    !['whole_rental', 'empty_house'].includes(input.propertyType)
  ) {
    warnings.push(
      '物件状態と「空室が目立っている」の回答が一致しないため、正式確認時に再確認します。',
    );
  }
  if (
    input.residencePlan === 'self_household' &&
    hasRentalIncomeIntent &&
    !MIXED_USE_ALLOWED_PREFECTURES.has(input.prefecture)
  ) {
    warnings.push(
      '賃貸併用住宅の優先対象地域外のため、自己使用・賃貸住宅・売却を比較しています。',
    );
  }
  if (
    mixedUseEligible &&
    input.currentHousing === 'own_home'
  ) {
    warnings.push(
      '現在持ち家にお住まいのため、住み替え・既存住宅の扱いを確認してから賃貸併用住宅を最終判定します。',
    );
  }
  if (
    (areaTier === 'regionalCore' || areaTier === 'specialMarket') &&
    hasRentalIncomeIntent &&
    input.residencePlan === 'none' &&
    !rentalBuildEligible
  ) {
    warnings.push(
      '賃貸建築の特別優先条件は「駅徒歩5分以内・50坪以上」です。',
    );
  }
  if (input.landArea === 'unknown') {
    warnings.push(
      '土地面積が不明のため、建物タイプは正式住所・地積確認後に再判定します。',
    );
  }

  const campaignEligible =
    !isSpecialLand &&
    input.propertyType !== 'self_use';

  return {
    primary,
    secondary,
    tertiary,
    reasons: createReasons(input, flags, primary),
    conditions,
    warnings,
    areaTier,
    effectiveLocation,
    campaignEligible,
    flags,
    scores: { main, build },
  };
}

type QuestionId =
  | 'prefecture'
  | 'propertyType'
  | 'stationDistance'
  | 'landArea'
  | 'residencePlan'
  | 'currentHousing'
  | 'priority'
  | 'concerns';

function getQuestionIds(answers: DiagnosisAnswers): QuestionId[] {
  const questions: QuestionId[] = [
    'prefecture',
    'propertyType',
    'stationDistance',
    'landArea',
    'residencePlan',
  ];

  if (needsHousingQuestion(answers.residencePlan)) {
    questions.push('currentHousing');
  }

  questions.push('priority', 'concerns');
  return questions;
}

const PROPERTY_OPTIONS: Array<{
  value: PropertyType;
  label: string;
}> = [
  { value: 'empty_house', label: '空き家が建っている' },
  { value: 'vacant_land', label: '更地になっている' },
  { value: 'parking', label: '駐車場として使っている' },
  { value: 'whole_rental', label: '一棟の賃貸物件がある' },
  { value: 'self_use', label: '現在、自分が使用し居住している' },
  { value: 'farmland', label: '畑・農地' },
  { value: 'forest', label: '山林' },
  { value: 'other', label: 'その他・分からない' },
];

const LAND_AREA_OPTIONS: Array<{
  value: LandArea;
  label: string;
}> = [
  { value: 'under_30', label: '30坪未満' },
  { value: '30_49', label: '30〜49坪' },
  { value: '50_79', label: '50〜79坪' },
  { value: '80_149', label: '80〜149坪' },
  { value: 'over_150', label: '150坪以上' },
  { value: 'unknown', label: '分からない' },
];

const RESIDENCE_OPTIONS: Array<{
  value: ResidencePlan;
  label: string;
  hint?: string;
}> = [
  {
    value: 'none',
    label: '誰も住む予定はない',
  },
  {
    value: 'self_household',
    label: '自分・配偶者・子どもが住む',
    hint: '本人世帯が住む予定',
  },
  {
    value: 'two_generation',
    label: '親世帯と子世帯で住む',
    hint: '二世帯での居住を想定',
  },
  {
    value: 'family_only',
    label: '親・子など家族だけが住む',
    hint: '申請者本人は住まない',
  },
  {
    value: 'undecided',
    label: 'まだ決めていない',
  },
];

const HOUSING_STATUS_OPTIONS: Array<{
  value: HousingStatus;
  label: string;
  hint?: string;
}> = [
  {
    value: 'own_home',
    label: '持ち家に住んでいる',
    hint: '戸建て・マンションを含む',
  },
  {
    value: 'rental_home',
    label: '賃貸住宅に住んでいる',
  },
  {
    value: 'family_home',
    label: '親族の持ち家に同居している',
  },
  {
    value: 'company_housing',
    label: '社宅・寮に住んでいる',
  },
  {
    value: 'other_unknown',
    label: 'その他・分からない',
  },
];

const PRIORITY_OPTIONS: Array<{
  value: Priority;
  label: string;
}> = [
  { value: 'rental_income', label: '継続的な家賃収入を得たい' },
  { value: 'sell', label: 'できるだけ高く売却したい' },
  { value: 'low_initial_cost', label: '初期費用を抑えて活用したい' },
  { value: 'self_use', label: '自分や家族で使用したい' },
  { value: 'end_ownership', label: 'とにかく保有を終えたい' },
  { value: 'undecided', label: 'まだ分からない' },
];

const BASE_CONCERNS: Array<{
  value: Concern;
  label: string;
  property?: PropertyType[];
}> = [
  {
    value: 'tax_burden',
    label: '固定資産税だけを払い続けている',
  },
  {
    value: 'maintenance_cost',
    label: '草刈りや建物管理に費用がかかる',
  },
  {
    value: 'aging_building',
    label: '建物の老朽化が心配',
    property: ['empty_house', 'whole_rental', 'self_use'],
  },
  {
    value: 'inheritance',
    label: '相続や名義整理に困っている',
  },
  {
    value: 'failed_sale',
    label: '売却を試したが買い手が見つからない',
  },
  {
    value: 'vacancy',
    label: '空室が目立っている',
    property: ['empty_house', 'whole_rental'],
  },
  {
    value: 'leasehold_dispute',
    label: '借地権・底地権で問題を抱えている',
  },
  {
    value: 'coownership_problem',
    label: '共有名義で問題を抱えている',
  },
  {
    value: 'none',
    label: '特に困っていない',
  },
];

const OWNER_RELATIONSHIP_OPTIONS = [
  { value: 'self', label: '申請者本人' },
  { value: 'spouse', label: '配偶者' },
  {
    value: 'family_approved',
    label: '親・祖父母・その他親族（了承済み）',
  },
  {
    value: 'coowner',
    label: '共有名義人の一人',
  },
  {
    value: 'other_approved',
    label: 'その他（所有者了承済み）',
  },
];

const initialAnswers: DiagnosisAnswers = {
  concerns: [],
};

const initialLead: LeadForm = {
  applicantName: '',
  ownerRelationship: '',
  ownerName: '',
  zip: '',
  cityTown: '',
  street: '',
  email: '',
  phone: '',
  privacyAccepted: false,
};

function normalizePhone(value: string): string {
  return value.replace(/[^\d]/g, '');
}

function validateContact(email: string, phone: string): boolean {
  const normalizedEmail = email.trim();
  const normalizedPhone = normalizePhone(phone);

  const emailValid =
    normalizedEmail.length > 0 &&
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalizedEmail);

  const phoneValid =
    normalizedPhone.length > 0 &&
    /^0[789]0\d{8}$/.test(normalizedPhone);

  return emailValid || phoneValid;
}

function normalizePostalTown(value: string): string {
  return value === '以下に掲載がない場合' ? '' : value;
}

function lookupPostalAddress(zip: string): Promise<PostalAddress> {
  return new Promise((resolve, reject) => {
    if (
      typeof window === 'undefined' ||
      typeof document === 'undefined'
    ) {
      reject(new Error('Postal lookup is browser-only.'));
      return;
    }

    const callbackName =
      `__zipcloud_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    const script = document.createElement('script');
    const callbackContainer =
      window as unknown as Record<string, unknown>;

    const cleanup = () => {
      window.clearTimeout(timeoutId);
      script.remove();
      delete callbackContainer[callbackName];
    };

    const timeoutId = window.setTimeout(() => {
      cleanup();
      reject(new Error('Postal lookup timed out.'));
    }, 8000);

    callbackContainer[callbackName] = (
      response: ZipCloudResponse,
    ) => {
      cleanup();
      const result = response.results?.[0];

      if (response.status !== 200 || !result) {
        reject(
          new Error(
            response.message ?? '住所が見つかりませんでした。',
          ),
        );
        return;
      }

      resolve({
        prefecture: result.address1,
        city: result.address2,
        town: normalizePostalTown(result.address3),
      });
    };

    script.onerror = () => {
      cleanup();
      reject(new Error('住所検索に接続できませんでした。'));
    };

    script.src =
      'https://zipcloud.ibsnet.co.jp/api/search' +
      `?zipcode=${encodeURIComponent(zip)}` +
      `&callback=${encodeURIComponent(callbackName)}`;
    script.async = true;
    document.head.appendChild(script);
  });
}

function questionTitle(
  id: QuestionId,
  prefecture?: string,
): { title: string; note: string } {
  switch (id) {
    case 'prefecture':
      return {
        title: '対象物件がある都道府県は？',
        note: 'エリア特性を簡易診断に反映します。',
      };
    case 'propertyType':
      return {
        title: '現在の物件状態は？',
        note: '最も近いものを1つ選んでください。',
      };
    case 'stationDistance':
      return {
        title:
          prefecture === '沖縄県'
            ? 'ゆいレール・主要市街地への近さは？'
            : '最寄り駅までの距離は？',
        note: '正確でなくても、分かる範囲で構いません。',
      };
    case 'landArea':
      return {
        title: 'おおよその土地面積は？',
        note: '正確な数値は不要です。「分からない」でも進めます。',
      };
    case 'residencePlan':
      return {
        title: 'この土地には、誰が住む予定ですか？',
        note: '二世帯住宅・賃貸併用住宅・自己使用を判定します。',
      };
    case 'currentHousing':
      return {
        title: '現在のお住まいは？',
        note: '持ち家の有無を、住み替えを伴う活用方法の判定に使います。',
      };
    case 'priority':
      return {
        title: '最も重視したいことは？',
        note: '今の考えに最も近いものを選んでください。',
      };
    case 'concerns':
      return {
        title: '現在、困っていることは？',
        note: '診断結果ではなく、活用時の前提条件として反映します。',
      };
  }
}

function stationOptions(
  prefecture?: string,
): Array<{ value: StationDistance; label: string }> {
  if (prefecture === '沖縄県') {
    return [
      {
        value: 'within_5_minutes',
        label: 'ゆいレール駅から徒歩5分以内',
      },
      {
        value: 'within_10_minutes',
        label: 'ゆいレール駅から徒歩6〜10分',
      },
      {
        value: 'within_20_minutes',
        label: '主要市街地へのアクセスが良い',
      },
      {
        value: 'car_centered',
        label: '車移動が中心',
      },
      {
        value: 'far_from_city',
        label: '市街地から離れている',
      },
      {
        value: 'unknown',
        label: '分からない',
      },
    ];
  }

  return [
    { value: 'within_5_minutes', label: '徒歩5分以内' },
    { value: 'within_10_minutes', label: '徒歩6〜10分' },
    { value: 'within_20_minutes', label: '徒歩11〜20分' },
    { value: 'over_20_minutes', label: '徒歩21分以上' },
    { value: 'car_centered', label: '車移動が中心' },
    { value: 'unknown', label: '分からない' },
  ];
}

const PROGRESS_STORAGE_KEYS = [
  'land-use-diagnosis-v4-7-mobile',
  'land-use-diagnosis-v4-8-mobile',
  'land-use-diagnosis-v4-9-mobile',
  'land-use-diagnosis-v5-0-mobile',
];

function clearDiagnosisProgress(): void {
  if (typeof window === 'undefined') return;

  PROGRESS_STORAGE_KEYS.forEach((key) => {
    window.localStorage.removeItem(key);
  });
}

export default function LandUseDiagnosisV63({
  submitEndpoint = '/api/land-use-diagnosis',
  previewMode = false,
  lineBuildUrl = '#line-build-consult',
  lineSellUrl = '#line-sell-consult',
  lineRightsUrl = '#line-rights-consult',
  heroScale = 1,
  onTrack,
}: Props) {
  const [stage, setStage] = useState<Stage>('intro');
  const [step, setStep] = useState(0);
  const [answers, setAnswers] =
    useState<DiagnosisAnswers>(initialAnswers);
  const [selectedPrefectureGroup, setSelectedPrefectureGroup] =
    useState('');
  const [lead, setLead] = useState<LeadForm>(initialLead);
  const [errors, setErrors] =
    useState<Record<string, string>>({});
  const [submitError, setSubmitError] = useState('');
  const [questionError, setQuestionError] = useState('');
  const [heroImageError, setHeroImageError] = useState(false);
  const [agreementModal, setAgreementModal] =
    useState<AgreementModalType | null>(null);

  const normalizedHeroScale = Number.isFinite(heroScale)
    ? Math.min(1, Math.max(0.7, heroScale))
    : 1;

  const [receiptId, setReceiptId] = useState('');
  const [postalLookupStatus, setPostalLookupStatus] =
    useState<PostalLookupStatus>('idle');
  const [postalLookupMessage, setPostalLookupMessage] =
    useState('');
  const [postalLookupNonce, setPostalLookupNonce] = useState(0);
  const lastLookedUpZipRef = useRef('');
  const postalRequestIdRef = useRef(0);
  const topRef = useRef<HTMLDivElement | null>(null);

  const questionIds = useMemo(
    () => getQuestionIds(answers),
    [answers.residencePlan],
  );
  const currentQuestion = questionIds[step] ?? questionIds[0];
  const progress =
    ((step + 1) / questionIds.length) * 100;
  const diagnosis = useMemo(
    () => diagnoseLandUse(answers),
    [answers],
  );

  const visibleConcerns = useMemo(
    () =>
      BASE_CONCERNS.filter(
        (item) =>
          !item.property ||
          (
            answers.propertyType &&
            item.property.includes(answers.propertyType)
          ),
      ),
    [answers.propertyType],
  );

  const track = (
    event: string,
    payload?: Record<string, unknown>,
  ) => {
    onTrack?.(event, payload);
  };

  useEffect(() => {
    console.info(
      `[Tochikatsu] UI version ${TOCHIKATSU_UI_VERSION} loaded`,
    );

    document.documentElement.dataset.tochikatsuVersion =
      TOCHIKATSU_UI_VERSION;

    /*
     * 再読み込み時は、診断途中の状態を復元せず、
     * 必ずトップ画面から開始します。
     */
    clearDiagnosisProgress();
    setStage('intro');
    setStep(0);
    setAnswers(initialAnswers);
    setSelectedPrefectureGroup('');
    setLead(initialLead);
    setErrors({});
    setSubmitError('');
    setQuestionError('');
    setHeroImageError(false);
    setAgreementModal(null);
    setReceiptId('');
    setPostalLookupStatus('idle');
    setPostalLookupMessage('');
  }, []);

  useEffect(() => {
    if (step >= questionIds.length) {
      setStep(Math.max(questionIds.length - 1, 0));
    }
  }, [questionIds.length, step]);

  useEffect(() => {
    topRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [step, stage]);

  useEffect(() => {
    if (stage !== 'form') return;

    const requestId = ++postalRequestIdRef.current;
    const normalizedZip =
      lead.zip.replace(/[^\d]/g, '');

    if (normalizedZip.length !== 7) {
      lastLookedUpZipRef.current = '';
      setPostalLookupStatus('idle');
      setPostalLookupMessage('');
      return;
    }

    if (
      lastLookedUpZipRef.current === normalizedZip
    ) return;

    const timerId = window.setTimeout(async () => {
      setPostalLookupStatus('loading');
      setPostalLookupMessage(
        '住所を検索しています…',
      );

      try {
        const address =
          await lookupPostalAddress(normalizedZip);

        if (
          requestId !== postalRequestIdRef.current
        ) return;

        lastLookedUpZipRef.current = normalizedZip;

        setLead((current) => ({
          ...current,
          zip: normalizedZip,
          cityTown: `${address.city}${address.town}`,
        }));

        setAnswers((current) => ({
          ...current,
          prefecture: address.prefecture,
        }));

        const matchedGroup =
          PREFECTURE_GROUPS.find((group) =>
            group.prefectures.some(
              (prefecture) =>
                prefecture === address.prefecture,
            ),
          );

        setSelectedPrefectureGroup(
          matchedGroup?.id ?? '',
        );

        setErrors((current) => {
          const next = { ...current };
          delete next.zip;
          delete next.cityTown;
          return next;
        });

        setPostalLookupStatus('success');
        setPostalLookupMessage(
          `${address.prefecture}${address.city}${address.town}まで自動入力しました。`,
        );

        track('postal_lookup_success', {
          prefecture: address.prefecture,
        });
      } catch {
        if (
          requestId !== postalRequestIdRef.current
        ) return;

        lastLookedUpZipRef.current = normalizedZip;
        setPostalLookupStatus('error');
        setPostalLookupMessage(
          '住所を自動取得できませんでした。市区町村・町名を直接入力してください。',
        );
        track('postal_lookup_error');
      }
    }, 280);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [lead.zip, postalLookupNonce, stage]);

  const retryPostalLookup = () => {
    lastLookedUpZipRef.current = '';
    setPostalLookupNonce((current) => current + 1);
  };

  const start = () => {
    setQuestionError('');
    setStep(0);
    setStage('questions');
    track('diagnosis_start');
  };

  const isQuestionAnswered = (
    questionId: QuestionId,
    currentAnswers: DiagnosisAnswers,
  ): boolean => {
    switch (questionId) {
      case 'prefecture':
        return Boolean(currentAnswers.prefecture);
      case 'propertyType':
        return Boolean(currentAnswers.propertyType);
      case 'stationDistance':
        return Boolean(currentAnswers.stationDistance);
      case 'landArea':
        return Boolean(currentAnswers.landArea);
      case 'residencePlan':
        return Boolean(currentAnswers.residencePlan);
      case 'currentHousing':
        return Boolean(currentAnswers.currentHousing);
      case 'priority':
        return Boolean(currentAnswers.priority);
      case 'concerns':
        return currentAnswers.concerns.length > 0;
      default:
        return false;
    }
  };

  const findFirstIncompleteQuestion = (
    currentAnswers: DiagnosisAnswers,
  ): QuestionId | null => {
    const questions = getQuestionIds(currentAnswers);

    return (
      questions.find(
        (questionId) =>
          !isQuestionAnswered(
            questionId,
            currentAnswers,
          ),
      ) ?? null
    );
  };

  const goToQuestion = (
    questionId: QuestionId,
    currentAnswers: DiagnosisAnswers = answers,
  ) => {
    const questions = getQuestionIds(currentAnswers);
    const nextIndex = questions.indexOf(questionId);

    setStage('questions');
    setStep(nextIndex >= 0 ? nextIndex : 0);
  };

  const selectSingle = <
    K extends keyof DiagnosisAnswers
  >(
    key: K,
    value: DiagnosisAnswers[K],
  ) => {
    const nextAnswers = {
      ...answers,
      [key]: value,
    };

    if (key === 'residencePlan') {
      const residenceValue =
        value as ResidencePlan;

      if (!needsHousingQuestion(residenceValue)) {
        delete nextAnswers.currentHousing;
      }
    }

    setAnswers(nextAnswers);
    setQuestionError('');

    track('question_answer', {
      question: key,
      value,
    });
  };

  const selectPropertyType = (
    value: PropertyType,
  ) => {
    const allowedConcerns = new Set(
      BASE_CONCERNS
        .filter(
          (item) =>
            !item.property ||
            item.property.includes(value),
        )
        .map((item) => item.value),
    );

    const nextAnswers = {
      ...answers,
      propertyType: value,
      concerns: answers.concerns.filter(
        (concern) =>
          allowedConcerns.has(concern),
      ),
    };

    setAnswers(nextAnswers);
    setQuestionError('');

    track('question_answer', {
      question: 'propertyType',
      value,
    });
  };

  const toggleConcern = (value: Concern) => {
    setQuestionError('');

    setAnswers((current) => {
      let nextConcerns: Concern[];

      if (value === 'none') {
        nextConcerns =
          current.concerns.includes('none')
            ? []
            : ['none'];
      } else {
        const withoutNone =
          current.concerns.filter(
            (item) => item !== 'none',
          );

        nextConcerns =
          withoutNone.includes(value)
            ? withoutNone.filter(
                (item) => item !== value,
              )
            : [...withoutNone, value];
      }

      const nextAnswers: DiagnosisAnswers = {
        ...current,
        concerns: nextConcerns,
      };

      track('question_answer', {
        question: 'concerns',
        value: nextConcerns,
      });

      return nextAnswers;
    });
  };

  const confirmConcerns = () => {
    const missingQuestion =
      findFirstIncompleteQuestion(answers);

    if (missingQuestion) {
      setQuestionError(
        '未回答の質問があります。該当する質問へ戻りました。',
      );
      goToQuestion(missingQuestion);
      return;
    }

    const nextDiagnosis =
      diagnoseLandUse(answers);

    if (!nextDiagnosis) {
      setQuestionError(
        '診断結果を作成できませんでした。回答内容をご確認ください。',
      );
      return;
    }

    setQuestionError('');
    setStage('result');

    track('diagnosis_teaser_view', {
      primary: nextDiagnosis.primary.key,
      campaignEligible:
        nextDiagnosis.campaignEligible,
    });
  };

  const advanceQuestion = () => {
    if (!isQuestionAnswered(currentQuestion, answers)) {
      setQuestionError(
        currentQuestion === 'concerns'
          ? '当てはまる項目を1つ以上選択してください。'
          : '選択肢を1つ選んでください。',
      );
      return;
    }

    if (currentQuestion === 'concerns') {
      confirmConcerns();
      return;
    }

    const questions = getQuestionIds(answers);
    const currentIndex =
      questions.indexOf(currentQuestion);
    const nextQuestion =
      questions[currentIndex + 1];

    if (!nextQuestion) {
      confirmConcerns();
      return;
    }

    setQuestionError('');
    setStep(currentIndex + 1);
  };

  const previous = () => {
    setQuestionError('');

    if (stage === 'result') {
      setStage('questions');
      setStep(questionIds.length - 1);
      return;
    }

    if (stage === 'form') {
      setStage('result');
      return;
    }

    if (step === 0) {
      setStage('intro');
      return;
    }

    setStep((current) => Math.max(current - 1, 0));
  };

  const validateLead = (): boolean => {
    const nextErrors: Record<string, string> = {};

    if (!lead.applicantName.trim()) {
      nextErrors.applicantName =
        'お名前を入力してください。';
    }

    if (!lead.ownerRelationship) {
      nextErrors.ownerRelationship =
        '登記名義人との関係を選択してください。';
    }

    if (
      lead.ownerRelationship !== 'self' &&
      !lead.ownerName.trim()
    ) {
      nextErrors.ownerName =
        '登記名義人のお名前を入力してください。';
    }

    if (
      !/^\d{7}$/.test(
        lead.zip.replace(/[^\d]/g, ''),
      )
    ) {
      nextErrors.zip =
        '郵便番号を7桁で入力してください。';
    }

    if (!answers.prefecture) {
      nextErrors.prefecture =
        '都道府県を選択してください。';
    }

    if (!lead.cityTown.trim()) {
      nextErrors.cityTown =
        '市区町村・町名を入力してください。';
    }

    if (!lead.street.trim()) {
      nextErrors.street =
        '番地以降を入力してください。';
    }

    if (!validateContact(
      lead.email,
      lead.phone,
    )) {
      nextErrors.contact =
        'メールアドレスまたはSMSを受け取れる携帯電話番号のどちらかを正しく入力してください。';
    }

    if (!lead.privacyAccepted) {
      nextErrors.privacyAccepted =
        '利用規約、キャンペーン規約および個人情報のお取扱いへの同意が必要です。';
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const submit = async () => {
    if (!validateLead()) return;

    const formalDiagnosis =
      diagnoseLandUse(answers);

    if (!formalDiagnosis) {
      setSubmitError(
        '診断結果を生成できませんでした。回答内容をご確認ください。',
      );
      return;
    }

    setStage('submitting');
    setSubmitError('');

    const submittedAt =
      new Date().toISOString();

    const payload = {
      answers,
      diagnosis: formalDiagnosis,
      lead: {
        ...lead,
        phone: normalizePhone(lead.phone),
      },
      submittedAt,
      meta: {
        uiVersion: TOCHIKATSU_UI_VERSION,
        pageUrl: window.location.href,
        referrer: document.referrer,
        userAgent: window.navigator.userAgent,
        language: window.navigator.language,
        timezone:
          Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
    };

    try {
      if (previewMode) {
        await new Promise((resolve) =>
          window.setTimeout(resolve, 650),
        );

        setReceiptId(
          `LS-${Date.now().toString().slice(-8)}`,
        );
      } else {
        const response = await fetch(
          submitEndpoint,
          {
            method: 'POST',
            headers: {
              'Content-Type':
                'application/json',
            },
            body: JSON.stringify(payload),
          },
        );

        if (!response.ok) {
          throw new Error(
            `Submission failed: ${response.status}`,
          );
        }

        const result = await response.json() as {
          success?: boolean;
          receiptId?: string;
        };

        if (!result.success) {
          throw new Error(
            'Server rejected submission.',
          );
        }

        setReceiptId(
          result.receiptId ??
          `LS-${Date.now().toString().slice(-8)}`,
        );
      }

      clearDiagnosisProgress();

      setStage('done');
      track('submit_success', {
        primary: formalDiagnosis.primary.key,
      });
    } catch (error) {
      console.error(
        '[Tochikatsu] submission failed',
        error,
      );
      setStage('form');
      setSubmitError(
        '送信を完了できませんでした。入力内容は保持されています。通信環境をご確認のうえ、もう一度お試しください。',
      );
      track('submit_error');
    }
  };

  const reset = () => {
    setStage('intro');
    setStep(0);
    setAnswers(initialAnswers);
    setSelectedPrefectureGroup('');
    setLead(initialLead);
    setErrors({});
    setSubmitError('');
    setQuestionError('');
    setHeroImageError(false);
    setAgreementModal(null);
    setReceiptId('');
    setPostalLookupStatus('idle');
    setPostalLookupMessage('');
    clearDiagnosisProgress();
  };

  const question = questionTitle(
    currentQuestion,
    answers.prefecture,
  );

  const formalDiagnosis =
    stage === 'done'
      ? diagnoseLandUse(answers)
      : null;

  const giftJourneyStep =
    stage === 'intro'
      ? 1
      : stage === 'questions'
        ? 2
        : stage === 'result' ||
            stage === 'form' ||
            stage === 'submitting'
          ? 3
          : 4;

  return (
    <div
      className="lu-root"
      ref={topRef}
      data-ui-version={TOCHIKATSU_UI_VERSION}
    >
      <style>{CSS}</style>

      {stage !== 'intro' && (
        <header className="lu-header lu-progress-header">
          <div className="lu-progress-header-meta">
            {stage === 'questions' ? (
              <button
                type="button"
                className="lu-back-link"
                onClick={previous}
              >
                ← 戻る
              </button>
            ) : (
              <span aria-hidden="true" />
            )}

            <span>
              {stage === 'questions'
                ? `${step + 1}/${questionIds.length}`
                : stage === 'form' ||
                    stage === 'submitting'
                  ? '入力'
                  : '完了'}
            </span>
          </div>

          <div
            className="lu-progress"
            role="progressbar"
            aria-valuemin={0}
            aria-valuemax={100}
            aria-valuenow={
              stage === 'questions'
                ? Math.round(progress)
                : stage === 'form' ||
                    stage === 'submitting'
                  ? 88
                  : 100
            }
          >
            <span
              style={{
                width:
                  stage === 'questions'
                    ? `${progress}%`
                    : stage === 'form' ||
                        stage === 'submitting'
                      ? '88%'
                      : '100%',
              }}
            />
          </div>
        </header>
      )}

      <main className="lu-main">
        <GiftJourney activeStep={giftJourneyStep} />

        {stage === 'intro' && (
          <section className="lu-card lu-intro">
            <div
              className={
                heroImageError
                  ? 'lu-top-creative lu-top-creative-error'
                  : 'lu-top-creative'
              }
            >
              <div
                className="lu-top-creative-media"
                style={{
                  width: `${normalizedHeroScale * 100}%`,
                }}
              >
                {!heroImageError ? (
                  <>
                    <img
                      src={topCreativeMobileV61}
                      alt=""
                      aria-hidden="true"
                      width={750}
                      height={920}
                      loading="eager"
                      decoding="async"
                      onLoad={() =>
                        setHeroImageError(false)
                      }
                      onError={() => {
                        console.error(
                          'トップ画像を読み込めませんでした。',
                          topCreativeMobileV61,
                        );
                        setHeroImageError(true);
                      }}
                    />

                    <div className="lu-hero-audience">
                      空き家・土地をお持ちの方へ
                    </div>

                    <div
                      className="lu-hero-benefit-copy"
                      aria-label="対象条件を満たした方に、Amazonギフトカード3,000円分"
                    >
                      <span className="lu-hero-benefit-top">
                        対象条件を満たした方に
                      </span>

                      <strong className="lu-hero-benefit-title">
                        Amazonギフトカード
                      </strong>

                      <div className="lu-hero-benefit-amount">
                        <b>3,000</b>
                        <em>円分</em>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="lu-hero-fallback">
                    <span>土地活用診断</span>
                    <strong>
                      あなたの土地の可能性を
                      <br />
                      最短1分で診断
                    </strong>
                    <p>
                      収益化・売却・その他の活用方法を比較します。
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="lu-gift-panel">
              <span>対象条件を満たした方全員に</span>
              <strong>
                Amazonギフトカード3,000円分
              </strong>
              <p>
                診断と必要情報の入力後、弊社から本人確認のご連絡をします。
                メールまたは電話等でご返答いただき、確認が取れた方には、
                <b>ご本人確認後</b>、
                ご登録のメールアドレスまたはSMSへ進呈します。
              </p>
            </div>

            <details className="lu-gift-conditions">
              <summary>主な特典対象条件を確認する</summary>
              <ul>
                <li>物件住所・所有者情報を正確に入力できること</li>
                <li>
                  弊社からの本人確認のご連絡に、メールまたは電話等で返答があり、確認が取れること
                </li>
                <li>
                  申込者本人が自己使用し居住している土地・建物、区分マンション、山林・農地、その他著しく活用の困難な地域にある土地（当社の判断）ではないこと
                </li>
              </ul>
              <p>
                対象外の場合も、確認結果と理由をご登録の連絡先へお知らせします。
              </p>
            </details>

            <button
              type="button"
              className="lu-primary"
              onClick={start}
            >
              対象条件を確認して診断を始める
            </button>
          </section>
        )}

        {stage === 'questions' && (
          <section className="lu-card">
            <div className="lu-question-heading">
              <span>QUESTION {step + 1}</span>
              <h2>{question.title}</h2>
            </div>

            {currentQuestion === 'prefecture' && (
              <>
                {!selectedPrefectureGroup ? (
                  <OptionCards
                    options={PREFECTURE_GROUPS.map(
                      (group) => ({
                        value: group.id,
                        label: group.label,
                      }),
                    )}
                    onSelect={
                      setSelectedPrefectureGroup
                    }
                  />
                ) : (
                  <>
                    <button
                      type="button"
                      className="lu-change-group"
                      onClick={() =>
                        setSelectedPrefectureGroup('')
                      }
                    >
                      地域グループを変更
                    </button>

                    <OptionCards
                      compact
                      options={
                        PREFECTURE_GROUPS
                          .find(
                            (group) =>
                              group.id ===
                              selectedPrefectureGroup,
                          )
                          ?.prefectures.map(
                            (prefecture) => ({
                              value: prefecture,
                              label: prefecture,
                            }),
                          ) ?? []
                      }
                      selected={answers.prefecture}
                      onSelect={(value) =>
                        selectSingle(
                          'prefecture',
                          value,
                        )
                      }
                    />
                  </>
                )}
              </>
            )}

            {currentQuestion ===
              'propertyType' && (
              <OptionCards
                options={PROPERTY_OPTIONS}
                selected={answers.propertyType}
                onSelect={(value) =>
                  selectPropertyType(
                    value as PropertyType,
                  )
                }
              />
            )}

            {currentQuestion ===
              'stationDistance' && (
              <OptionCards
                options={stationOptions(
                  answers.prefecture,
                )}
                selected={
                  answers.stationDistance
                }
                onSelect={(value) =>
                  selectSingle(
                    'stationDistance',
                    value as StationDistance,
                  )
                }
              />
            )}

            {currentQuestion === 'landArea' && (
              <OptionCards
                options={LAND_AREA_OPTIONS}
                selected={answers.landArea}
                onSelect={(value) =>
                  selectSingle(
                    'landArea',
                    value as LandArea,
                  )
                }
              />
            )}

            {currentQuestion ===
              'residencePlan' && (
              <OptionCards
                options={RESIDENCE_OPTIONS}
                selected={answers.residencePlan}
                onSelect={(value) =>
                  selectSingle(
                    'residencePlan',
                    value as ResidencePlan,
                  )
                }
              />
            )}

            {currentQuestion ===
              'currentHousing' && (
              <OptionCards
                options={HOUSING_STATUS_OPTIONS}
                selected={answers.currentHousing}
                onSelect={(value) =>
                  selectSingle(
                    'currentHousing',
                    value as HousingStatus,
                  )
                }
              />
            )}

            {currentQuestion === 'priority' && (
              <OptionCards
                options={PRIORITY_OPTIONS}
                selected={answers.priority}
                onSelect={(value) =>
                  selectSingle(
                    'priority',
                    value as Priority,
                  )
                }
              />
            )}

            {currentQuestion === 'concerns' && (
              <div className="lu-option-list">
                {visibleConcerns.map((option) => {
                  const selected =
                    answers.concerns.includes(
                      option.value,
                    );

                  return (
                    <button
                      type="button"
                      key={option.value}
                      className={
                        selected
                          ? 'lu-option lu-option-selected'
                          : 'lu-option'
                      }
                      onClick={() =>
                        toggleConcern(option.value)
                      }
                    >
                      <span>
                        {option.label}
                      </span>
                      <b>
                        {selected ? '✓' : ''}
                      </b>
                    </button>
                  );
                })}
              </div>
            )}

            {questionError && (
              <p
                className="lu-question-error"
                role="alert"
              >
                {questionError}
              </p>
            )}

            <button
              type="button"
              className="lu-primary lu-sticky"
              disabled={
                !isQuestionAnswered(
                  currentQuestion,
                  answers,
                )
              }
              onClick={advanceQuestion}
            >
              {currentQuestion === 'concerns'
                ? '選択した内容で診断する'
                : 'この回答で次へ進む'}
            </button>
          </section>
        )}

        {stage === 'result' && diagnosis && (
          <TeaserView
            answers={answers}
            diagnosis={diagnosis}
            onBack={previous}
            onContinue={() => {
              setStage('form');
              track('lead_form_view', {
                teaserPrimary:
                  diagnosis.primary.key,
              });
            }}
          />
        )}

        {stage === 'form' && diagnosis && (
          <section className="lu-card">
            <button
              type="button"
              className="lu-back-link"
              onClick={previous}
            >
              ← 分析画面に戻る
            </button>

            <div className="lu-question-heading">
              <span>FINAL STEP</span>
              <h2>
                正式な診断結果を確認する
              </h2>
              <p>
                正式結果の表示まであと1ステップです。
                物件住所とご本人情報をご入力ください。
                郵便番号から町名まで自動入力できます。
              </p>
            </div>

            <div className="lu-form-gift-note">
              <strong>特典進呈までの流れ</strong>
              <span>情報入力 → ご本人確認 → 14日以内に進呈</span>
              <small>
                対象条件を満たした方には、
                ご本人確認後にメールまたはSMSで進呈します。
              </small>
            </div>

            <FormSection title="申請者情報">
              <Field
                label="お名前"
                required
                error={errors.applicantName}
              >
                <input
                  type="text"
                  autoComplete="name"
                  value={lead.applicantName}
                  onChange={(event) =>
                    setLead((current) => ({
                      ...current,
                      applicantName:
                        event.target.value,
                    }))
                  }
                />
              </Field>

              <Field
                label="登記名義人との関係"
                required
                error={errors.ownerRelationship}
              >
                <select
                  value={lead.ownerRelationship}
                  onChange={(event) =>
                    setLead((current) => ({
                      ...current,
                      ownerRelationship:
                        event.target.value,
                    }))
                  }
                >
                  <option value="">
                    選択してください
                  </option>
                  {OWNER_RELATIONSHIP_OPTIONS.map(
                    (option) => (
                      <option
                        key={option.value}
                        value={option.value}
                      >
                        {option.label}
                      </option>
                    ),
                  )}
                </select>
              </Field>

              {lead.ownerRelationship &&
                lead.ownerRelationship !== 'self' && (
                  <Field
                    label="登記名義人のお名前"
                    required
                    error={errors.ownerName}
                  >
                    <input
                      type="text"
                      value={lead.ownerName}
                      onChange={(event) =>
                        setLead((current) => ({
                          ...current,
                          ownerName:
                            event.target.value,
                        }))
                      }
                    />
                  </Field>
                )}
            </FormSection>

            <FormSection title="対象物件の住所">
              <Field
                label="郵便番号"
                required
                error={errors.zip}
              >
                <input
                  type="text"
                  inputMode="numeric"
                  autoComplete="postal-code"
                  maxLength={8}
                  placeholder="例：7300001"
                  value={lead.zip}
                  onChange={(event) =>
                    setLead((current) => ({
                      ...current,
                      zip: event.target.value
                        .replace(/[^\d-]/g, '')
                        .slice(0, 8),
                    }))
                  }
                />
              </Field>

              {postalLookupStatus !== 'idle' && (
                <div
                  className={
                    postalLookupStatus === 'error'
                      ? 'lu-postal lu-postal-error'
                      : 'lu-postal'
                  }
                >
                  <span>{postalLookupMessage}</span>
                  {postalLookupStatus === 'error' && (
                    <button
                      type="button"
                      onClick={retryPostalLookup}
                    >
                      再検索
                    </button>
                  )}
                </div>
              )}

              <Field
                label="都道府県"
                required
                error={errors.prefecture}
              >
                <select
                  value={answers.prefecture ?? ''}
                  onChange={(event) =>
                    setAnswers((current) => ({
                      ...current,
                      prefecture:
                        event.target.value,
                    }))
                  }
                >
                  <option value="">
                    選択してください
                  </option>
                  {PREFECTURES.map(
                    (prefecture) => (
                      <option
                        key={prefecture}
                        value={prefecture}
                      >
                        {prefecture}
                      </option>
                    ),
                  )}
                </select>
              </Field>

              <Field
                label="市区町村・町名"
                required
                error={errors.cityTown}
              >
                <input
                  type="text"
                  autoComplete="address-level2"
                  placeholder="郵便番号から自動入力"
                  value={lead.cityTown}
                  onChange={(event) =>
                    setLead((current) => ({
                      ...current,
                      cityTown:
                        event.target.value,
                    }))
                  }
                />
              </Field>

              <Field
                label="番地以降"
                required
                error={errors.street}
              >
                <input
                  type="text"
                  autoComplete="street-address"
                  placeholder="例：1-1-1"
                  value={lead.street}
                  onChange={(event) =>
                    setLead((current) => ({
                      ...current,
                      street:
                        event.target.value,
                    }))
                  }
                />
              </Field>
            </FormSection>

            <FormSection title="本人確認用の連絡先">
              <p className="lu-section-note">
                メールアドレスまたはSMSを受け取れる携帯電話番号のどちらか一方をご入力ください。
              </p>

              <Field
                label="メールアドレス"
                error={errors.contact}
              >
                <input
                  type="email"
                  inputMode="email"
                  autoComplete="email"
                  value={lead.email}
                  onChange={(event) =>
                    setLead((current) => ({
                      ...current,
                      email: event.target.value,
                    }))
                  }
                />
              </Field>

              <div className="lu-or">または</div>

              <Field
                label="携帯電話番号（SMS受信可能）"
                error={!lead.email ? errors.contact : undefined}
              >
                <input
                  type="tel"
                  inputMode="tel"
                  autoComplete="tel"
                  placeholder="例：09012345678"
                  value={lead.phone}
                  onChange={(event) =>
                    setLead((current) => ({
                      ...current,
                      phone: event.target.value,
                    }))
                  }
                />
              </Field>
            </FormSection>

            <div className="lu-consent-single">
              <input
                id="legal-privacy-consent"
                type="checkbox"
                checked={lead.privacyAccepted}
                onChange={(event) =>
                  setLead((current) => ({
                    ...current,
                    privacyAccepted:
                      event.target.checked,
                  }))
                }
                aria-describedby="legal-privacy-consent-copy"
              />

              <div
                id="legal-privacy-consent-copy"
                className="lu-consent-single-copy"
              >
                <p>
                  <button
                    type="button"
                    className="lu-inline-legal-link"
                    onClick={() =>
                      setAgreementModal('serviceTerms')
                    }
                  >
                    利用規約
                  </button>
                  、
                  <button
                    type="button"
                    className="lu-inline-legal-link"
                    onClick={() =>
                      setAgreementModal('campaignTerms')
                    }
                  >
                    キャンペーン規約
                  </button>
                  および
                  <a
                    className="lu-inline-legal-link"
                    href={PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    個人情報の取扱い
                  </a>
                  に同意します。
                </p>

                <label htmlFor="legal-privacy-consent">
                  入力情報は、本人確認、入力内容の確認、診断結果および特典進呈の連絡に使用します。
                </label>
              </div>
            </div>

            {errors.privacyAccepted && (
              <p className="lu-error">
                {errors.privacyAccepted}
              </p>
            )}

            {submitError && (
              <div className="lu-error-box">
                {submitError}
              </div>
            )}

            <div className="lu-submit-assurance">
              <strong>送信後の流れ</strong>
              <p>
                正式な診断結果は送信後すぐに表示されます。
                その後、ご本人確認を行い、対象条件を満たした方には
                ご本人確認後にAmazonギフトカード3,000円分を進呈します。
              </p>
            </div>

            <button
              type="button"
              className="lu-primary"
              onClick={submit}
            >
              入力内容を送信して正式結果を見る
            </button>
          </section>
        )}

        {stage === 'submitting' && (
          <section className="lu-card lu-center">
            <div className="lu-spinner" />
            <h2>正式結果を作成しています</h2>
            <p>
              入力内容と所在地を反映しています。
            </p>
          </section>
        )}

        {stage === 'done' &&
          formalDiagnosis && (
            <ResultView
              diagnosis={formalDiagnosis}
              title="正式診断結果"
              location={
                `${answers.prefecture ?? ''}` +
                `${lead.cityTown}${lead.street}`
              }
              receiptId={receiptId}
              action={
                <>
                  <ResultMarketingCtas
                    diagnosis={formalDiagnosis}
                    buildUrl={lineBuildUrl}
                    sellUrl={lineSellUrl}
                    rightsUrl={lineRightsUrl}
                    onTrack={track}
                  />

                  {formalDiagnosis.campaignEligible && (
                    <GiftStatusPanel
                      contactMethod={
                        lead.email ? 'メール' : 'SMS'
                      }
                    />
                  )}

                  <button
                    type="button"
                    className="lu-secondary"
                    onClick={reset}
                  >
                    最初から診断する
                  </button>
                </>
              }
            />
          )}
      </main>

      {agreementModal && (
        <AgreementModal
          type={agreementModal}
          onClose={() =>
            setAgreementModal(null)
          }
        />
      )}
    </div>
  );
}



function AgreementModal({
  type,
  onClose,
}: {
  type: AgreementModalType;
  onClose: () => void;
}) {
  const closeButtonRef =
    useRef<HTMLButtonElement | null>(null);

  const isServiceTerms =
    type === 'serviceTerms';

  const title = isServiceTerms
    ? '土地活用WEB診断 利用規約'
    : 'キャンペーン規約';

  const version = isServiceTerms
    ? SERVICE_TERMS_VERSION
    : CAMPAIGN_TERMS_VERSION;

  const sections = isServiceTerms
    ? SERVICE_TERMS_SECTIONS
    : CAMPAIGN_TERMS_SECTIONS;

  useEffect(() => {
    const previousActiveElement =
      document.activeElement as HTMLElement | null;
    const previousOverflow =
      document.body.style.overflow;

    document.body.style.overflow = 'hidden';
    closeButtonRef.current?.focus();

    const handleKeyDown = (
      event: KeyboardEvent,
    ) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener(
      'keydown',
      handleKeyDown,
    );

    return () => {
      document.body.style.overflow =
        previousOverflow;
      document.removeEventListener(
        'keydown',
        handleKeyDown,
      );
      previousActiveElement?.focus();
    };
  }, [onClose]);

  return (
    <div
      className="lu-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (
          event.target === event.currentTarget
        ) {
          onClose();
        }
      }}
    >
      <section
        className="lu-modal-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lu-agreement-title"
      >
        <header className="lu-modal-header">
          <div>
            <span>最終更新日：{version}</span>
            <h2 id="lu-agreement-title">
              {title}
            </h2>
          </div>

          <button
            ref={closeButtonRef}
            type="button"
            className="lu-modal-close"
            onClick={onClose}
            aria-label={`${title}を閉じる`}
          >
            ×
          </button>
        </header>

        <div className="lu-modal-body">
          <p className="lu-modal-lead">
            内容を最後までご確認ください。
          </p>

          {sections.map((section) => (
            <article
              key={section.heading}
              className="lu-terms-section"
            >
              <h3>{section.heading}</h3>

              {section.paragraphs?.map(
                (paragraph) => (
                  <p key={paragraph}>
                    {paragraph}
                  </p>
                ),
              )}

              {section.items && (
                <ul>
                  {section.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </article>
          ))}

          <p className="lu-modal-reference">
            <a
              href={
                isServiceTerms
                  ? GENERAL_TERMS_URL
                  : PRIVACY_POLICY_URL
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {isServiceTerms
                ? 'マイホームヒーローズ利用規約も確認する'
                : '個人情報のお取扱いを確認する'}
            </a>
          </p>
        </div>

        <footer className="lu-modal-footer">
          <button
            type="button"
            className="lu-primary"
            onClick={onClose}
          >
            内容を確認して閉じる
          </button>
        </footer>
      </section>
    </div>
  );
}

function GiftJourney({
  activeStep,
}: {
  activeStep: number;
}) {
  const steps = [
    '対象条件',
    '土地活用診断',
    '物件・本人情報',
    '本人確認・進呈',
  ];

  return (
    <nav
      className="lu-gift-journey"
      aria-label="Amazonギフトカード進呈までの流れ"
    >
      <div className="lu-gift-journey-title">
        <strong>特典進呈までの流れ</strong>
        <span>ご本人確認後</span>
      </div>

      <ol>
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          const completed = stepNumber < activeStep;
          const active = stepNumber === activeStep;

          return (
            <li
              key={label}
              className={
                completed
                  ? 'lu-journey-completed'
                  : active
                    ? 'lu-journey-active'
                    : ''
              }
              aria-current={active ? 'step' : undefined}
            >
              <b>{completed ? '✓' : stepNumber}</b>
              <span>{label}</span>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}


function optionLabel(
  options: Array<{ value: string; label: string }>,
  value?: string,
): string {
  if (!value) return '';
  return (
    options.find((option) => option.value === value)
      ?.label ?? value
  );
}

function getTeaserInsight(
  answers: DiagnosisAnswers,
): string {
  if (
    answers.concerns.includes('leasehold_dispute') ||
    answers.concerns.includes('coownership_problem')
  ) {
    return '権利関係の確認が必要な状態ですが、整理後に比較すべき土地活用プランまで絞り込めています。';
  }

  if (answers.concerns.includes('vacancy')) {
    return '空室状況と現在の保有コストをどう改善するかが、資産価値を左右する状態です。';
  }

  if (
    answers.propertyType === 'farmland' ||
    answers.propertyType === 'forest'
  ) {
    return '土地の種別、利用予定、維持負担の組み合わせが、今後の保有判断の鍵になる状態です。';
  }

  if (answers.residencePlan === 'two_generation') {
    return '土地の広さと親世帯・子世帯の住まい方を両立できるかが、判断の鍵になる状態です。';
  }

  if (
    answers.residencePlan === 'self_household' &&
    answers.priority === 'rental_income'
  ) {
    return 'ご自身の住まいと収益性をどう両立するかが、最適な建築プランを選ぶ鍵になります。';
  }

  if (answers.priority === 'rental_income') {
    return '立地、土地の広さ、居住予定の組み合わせが、収益化の可能性を左右する状態です。';
  }

  if (answers.priority === 'sell') {
    return '現在の保有負担と土地の市場性を比較し、現金化の進め方を見極めることが鍵になります。';
  }

  if (answers.priority === 'low_initial_cost') {
    return '初期費用を抑えながら、保有コストを軽減できる方法を選ぶことが鍵になります。';
  }

  if (answers.priority === 'end_ownership') {
    return '売却可能性だけでなく、保有を終了するまでの費用と手順を比較する必要があります。';
  }

  return 'エリア、土地の広さ、将来の利用予定を組み合わせることで、有力な活用方法を絞り込めています。';
}

function TeaserView({
  answers,
  diagnosis,
  onBack,
  onContinue,
}: {
  answers: DiagnosisAnswers;
  diagnosis: DiagnosisResult;
  onBack: () => void;
  onContinue: () => void;
}) {
  const stationLabel = optionLabel(
    stationOptions(answers.prefecture),
    answers.stationDistance,
  );
  const areaLabel = optionLabel(
    LAND_AREA_OPTIONS,
    answers.landArea,
  );
  const priorityLabel = optionLabel(
    PRIORITY_OPTIONS,
    answers.priority,
  );

  return (
    <section className="lu-card">
      <button
        type="button"
        className="lu-back-link"
        onClick={onBack}
      >
        ← 回答を修正
      </button>

      <div className="lu-teaser-head">
        <span>回答内容の分析が完了しました</span>
        <h2>
          あなたの土地に合う
          <br />
          有力な活用プランが
          <em>2つ</em>に絞られました
        </h2>
        <p>{getTeaserInsight(answers)}</p>
      </div>

      <div className="lu-analysis-proof">
        <strong>今回の判定に反映した内容</strong>
        <div className="lu-analysis-chips">
          {answers.prefecture && (
            <span>{answers.prefecture}</span>
          )}
          {areaLabel && <span>{areaLabel}</span>}
          {stationLabel && <span>{stationLabel}</span>}
          {priorityLabel && <span>{priorityLabel}</span>}
        </div>
        <small>
          回答内容に応じて、立地条件・面積・居住意向・
          保有上の課題を個別に判定しています。
        </small>
      </div>

      <div className="lu-locked-result">
        <div>
          <span>正式結果で確認できます</span>
          <strong>第一候補と比較すべき活用方法</strong>
        </div>
        <b>判定済み</b>
      </div>

      {diagnosis.flags.hasRightsIssue && (
        <p className="lu-teaser-note">
          権利関係の回答は活用方法の順位には含めず、
          実行前の確認事項として正式結果に表示します。
        </p>
      )}

      <div className="lu-gift-next">
        <strong>特典進呈まで残り2ステップ</strong>
        <ol>
          <li>物件住所・ご本人情報を入力</li>
          <li>入力内容をもとにご本人確認</li>
        </ol>
        <small>
          対象条件を満たした方には、
          ご本人確認後にメールまたはSMSで進呈します。
        </small>
      </div>

      <button
        type="button"
        className="lu-primary"
        onClick={onContinue}
      >
        正式な診断結果を確認する
      </button>

      <p className="lu-under-cta">
        送信後、第一候補・比較候補・判定理由をすぐに表示します。
      </p>
    </section>
  );
}

function ResultMarketingCtas({
  diagnosis,
  buildUrl,
  sellUrl,
  rightsUrl,
  onTrack,
}: {
  diagnosis: DiagnosisResult;
  buildUrl: string;
  sellUrl: string;
  rightsUrl: string;
  onTrack: (
    event: string,
    payload?: Record<string, unknown>,
  ) => void;
}) {
  const hasRightsIssue =
    diagnosis.flags.hasRightsIssue;
  const isRentalBuild =
    diagnosis.primary.route === 'build' &&
    (
      diagnosis.primary.subtype === 'apartment' ||
      diagnosis.primary.subtype === 'rentalHouse'
    );
  const isSell =
    diagnosis.primary.route === 'sell';

  if (hasRightsIssue) {
    return (
      <section className="lu-rights-cta">
        <strong>
          まずは権利関係または共有状態を整理しましょう
        </strong>
        <p>
          マイホームヒーローズでは、
          権利関係・共有名義の整理に関するご相談から
          無料で承ります。
        </p>
        <a
          href={rightsUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            onTrack('line_cta_click', {
              type: 'rights',
            })
          }
        >
          権利関係をLINEで無料相談する
        </a>
      </section>
    );
  }

  if (isRentalBuild) {
    return (
      <section className="lu-result-cta lu-build-cta">
        <span>診断結果に合う次の一歩</span>
        <strong>
          土地条件に合う建築会社を比較しましょう
        </strong>
        <p>
          実家の土地を上手く活用し、
          手取り月20万円・年間240万円を超える
          副収入を得た事例もあります。
          大切なのは、土地条件に合う建築会社を
          選ぶことです。
        </p>
        <p>
          どのような会社が合うか知りたい方は、
          LINEの無料相談へお進みください。
        </p>
        <a
          href={buildUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            onTrack('line_cta_click', {
              type: 'build',
              result: diagnosis.primary.key,
            })
          }
        >
          建築会社選びをLINEで無料相談する
        </a>
        <small>
          ※個別の活用事例であり、
          収益額を保証するものではありません。
          立地、建築費、融資条件、賃料などにより異なります。
        </small>
      </section>
    );
  }

  if (isSell) {
    return (
      <section className="lu-result-cta lu-sell-cta">
        <span>診断結果に合う次の一歩</span>
        <strong>
          より良い条件を提示できる不動産会社を探します
        </strong>
        <p>
          マイホームヒーローズでは、
          お客様に代わって複数の候補を確認し、
          より高い条件を提示できる可能性のある
          不動産会社を探します。
        </p>
        <p>
          余計なコンサルティング費用はいただかず、
          複数の不動産会社から営業電話が相次ぐこともありません。
          どこが高く買ってくれそうか知りたい方は、
          LINEの無料相談へお進みください。
        </p>
        <a
          href={sellUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() =>
            onTrack('line_cta_click', {
              type: 'sell',
            })
          }
        >
          高値売却の可能性をLINEで無料相談する
        </a>
        <small>
          ※売却価格や購入条件を保証するものではありません。
          物件条件と査定結果により異なります。
        </small>
      </section>
    );
  }

  return null;
}


function GiftStatusPanel({
  contactMethod,
}: {
  contactMethod: 'メール' | 'SMS';
}) {
  return (
    <div className="lu-gift-status-panel">
      <div className="lu-gift-status-head">
        <strong>Amazonギフトカードの確認状況</strong>
        <span>ご本人確認中</span>
      </div>

      <dl>
        <div>
          <dt>お客様による追加操作</dt>
          <dd>本人確認のご連絡にご返答ください</dd>
        </div>
        <div>
          <dt>確認結果の通知先</dt>
          <dd>ご登録の{contactMethod}</dd>
        </div>
        <div>
          <dt>進呈時期</dt>
          <dd>ご本人確認後</dd>
        </div>
      </dl>

      <p>
        本人確認のため、ご登録のメールアドレスまたは携帯電話番号へご連絡します。
        メールまたは電話等でご返答いただき、確認が取れた後に結果をお知らせします。
        対象外の場合も確認結果と理由をご案内します。
      </p>
    </div>
  );
}

function ResultView({
  diagnosis,
  title,
  location,
  receiptId,
  onBack,
  action,
}: {
  diagnosis: DiagnosisResult;
  title: string;
  location?: string;
  receiptId?: string;
  onBack?: () => void;
  action: React.ReactNode;
}) {
  const comparisons = [
    diagnosis.secondary,
    diagnosis.tertiary,
  ].filter(
    (
      candidate,
    ): candidate is DiagnosisCandidate =>
      Boolean(candidate),
  );

  return (
    <section className="lu-card">
      {onBack && (
        <button
          type="button"
          className="lu-back-link"
          onClick={onBack}
        >
          ← 回答を修正
        </button>
      )}

      <div className="lu-result-head">
        <span>{title}</span>
        <h2>
          第一候補は
          <br />
          「{diagnosis.primary.label}」
        </h2>

        {location && (
          <p className="lu-location">
            診断対象：{location}
          </p>
        )}

        {receiptId && (
          <p className="lu-receipt">
            受付番号：{receiptId}
          </p>
        )}
      </div>


      <div className="lu-primary-result">
        <span>第一候補</span>
        <strong>
          {diagnosis.primary.label}
        </strong>
        <p>
          {diagnosis.primary.description}
        </p>
      </div>

      <div className="lu-reason-panel">
        <strong>この結果になった理由</strong>
        {diagnosis.reasons.map((reason) => (
          <div
            key={reason}
            className="lu-reason"
          >
            <b>✓</b>
            <span>{reason}</span>
          </div>
        ))}
      </div>

      {comparisons.length > 0 && (
        <>
          <h3 className="lu-subheading">
            比較する活用方法
          </h3>

          <div className="lu-comparison-grid">
            {comparisons.map(
              (candidate, index) => (
                <div
                  key={candidate.key}
                  className="lu-comparison"
                >
                  <span>{index + 2}</span>
                  <strong>{candidate.label}</strong>
                  <p>{candidate.description}</p>
                </div>
              ),
            )}
          </div>
        </>
      )}

      {diagnosis.conditions.length > 0 &&
        !diagnosis.flags.hasRightsIssue && (
        <div className="lu-condition-panel">
          <strong>活用前に確認する条件</strong>
          {diagnosis.conditions.map(
            (condition) => (
              <p key={condition}>
                ・{condition}
              </p>
            ),
          )}
        </div>
      )}

      {diagnosis.warnings.length > 0 && (
        <div className="lu-warning-panel">
          <strong>正式判定で確認する項目</strong>
          {diagnosis.warnings.map(
            (warning) => (
              <p key={warning}>
                ・{warning}
              </p>
            ),
          )}
        </div>
      )}

      {!diagnosis.campaignEligible && (
        <div className="lu-campaign-notice">
          この物件種別は特典対象外ですが、診断結果は確認できます。
        </div>
      )}

      {action}
    </section>
  );
}

function OptionCards({
  options,
  selected,
  onSelect,
  compact = false,
}: {
  options: Array<{
    value: string;
    label: string;
    hint?: string;
  }>;
  selected?: string;
  onSelect: (value: string) => void;
  compact?: boolean;
}) {
  return (
    <div
      className={
        compact
          ? 'lu-options lu-options-compact'
          : 'lu-options'
      }
    >
      {options.map((option) => {
        const isSelected =
          selected === option.value;

        return (
          <button
            type="button"
            key={option.value}
            className={
              isSelected
                ? 'lu-option lu-option-selected'
                : 'lu-option'
            }
            onClick={() =>
              onSelect(option.value)
            }
          >
            <span>
              <strong>{option.label}</strong>
              {option.hint && (
                <small>{option.hint}</small>
              )}
            </span>
            <b>{isSelected ? '✓' : '›'}</b>
          </button>
        );
      })}
    </div>
  );
}

function FormSection({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) {
  return (
    <section className="lu-form-section">
      <h3>{title}</h3>
      {children}
    </section>
  );
}

function Field({
  label,
  required,
  error,
  children,
}: {
  label: string;
  required?: boolean;
  error?: string;
  children: React.ReactNode;
}) {
  return (
    <label className="lu-field">
      <span>
        {label}
        {required && <b>必須</b>}
      </span>
      {children}
      {error && (
        <small className="lu-error">
          {error}
        </small>
      )}
    </label>
  );
}

const CSS = `
  * { box-sizing: border-box; }
  .lu-root {
    min-height: 100vh;
    background: #eef3f8;
    color: #17324d;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI",
      "Hiragino Kaku Gothic ProN", "Yu Gothic", sans-serif;
  }
  .lu-header {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 14px max(18px, calc((100vw - 720px) / 2));
    background: rgba(255,255,255,.97);
    border-bottom: 1px solid #dce5ee;
    backdrop-filter: blur(8px);
  }
  .lu-header > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .lu-header strong { font-size: 14px; }
  .lu-header span { font-size: 11px; color: #6d7d8e; }
  .lu-gift {
    min-width: 104px;
    padding: 7px 10px;
    border: 1px solid #f2c979;
    border-radius: 12px;
    background: #fff6e5;
    text-align: center;
  }
  .lu-gift span, .lu-gift strong {
    display: block;
    color: #84500a;
  }
  .lu-gift strong { font-size: 14px; }
  .lu-main {
    width: min(100%, 720px);
    margin: 0 auto;
    padding: 18px 12px 48px;
  }
  .lu-card {
    padding: 24px;
    border: 1px solid #dfe7ef;
    border-radius: 22px;
    background: #fff;
    box-shadow: 0 14px 38px rgba(25, 53, 80, .08);
  }
  .lu-intro { padding-top: 34px; }
  .lu-eyebrow {
    display: inline-block;
    padding: 6px 11px;
    border-radius: 999px;
    background: #e9f2fb;
    color: #165c91;
    font-size: 12px;
    font-weight: 700;
  }
  .lu-intro h1 {
    margin: 18px 0 14px;
    font-size: clamp(27px, 7vw, 42px);
    line-height: 1.25;
    letter-spacing: -.035em;
  }
  .lu-intro > p {
    margin: 0;
    color: #657589;
    line-height: 1.8;
  }
  .lu-gift-panel {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin: 24px 0;
    padding: 17px;
    border: 1px solid #f0cc85;
    border-radius: 16px;
    background: #fff8e9;
    color: #84500a;
  }
  .lu-gift-panel strong { font-size: 19px; }
  button, input, select { font: inherit; }
  button { touch-action: manipulation; }
  .lu-primary, .lu-secondary {
    width: 100%;
    min-height: 56px;
    border: 0;
    border-radius: 14px;
    font-weight: 800;
    cursor: pointer;
  }
  .lu-primary {
    background: #0f5b94;
    color: #fff;
    box-shadow: 0 8px 20px rgba(15, 91, 148, .22);
  }
  .lu-primary:disabled {
    background: #aebbc6;
    box-shadow: none;
    cursor: not-allowed;
  }
  .lu-secondary {
    margin-top: 18px;
    background: #e9f0f6;
    color: #24435f;
  }
  .lu-sticky {
    position: sticky;
    bottom: 12px;
    margin-top: 18px;
  }
  .lu-progress-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #748496;
    font-size: 12px;
  }
  .lu-back-link, .lu-change-group {
    border: 0;
    background: transparent;
    color: #3f6687;
    cursor: pointer;
  }
  .lu-progress {
    height: 6px;
    margin: 12px 0 24px;
    overflow: hidden;
    border-radius: 999px;
    background: #e8eef4;
  }
  .lu-progress span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: #0f5b94;
    transition: width .25s ease;
  }
  .lu-question-heading > span,
  .lu-result-head > span {
    color: #17639e;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: .12em;
  }
  .lu-question-heading h2,
  .lu-result-head h2 {
    margin: 8px 0;
    font-size: clamp(23px, 6vw, 31px);
    line-height: 1.35;
  }
  .lu-question-heading p,
  .lu-result-head p {
    margin: 0 0 22px;
    color: #6b7b8c;
    line-height: 1.7;
  }
  .lu-change-group {
    margin-bottom: 10px;
    padding: 6px 0;
  }
  .lu-options {
    display: grid;
    gap: 10px;
  }
  .lu-options-compact {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .lu-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 58px;
    padding: 14px 16px;
    border: 1px solid #d8e2eb;
    border-radius: 14px;
    background: #fff;
    color: #203a54;
    text-align: left;
    cursor: pointer;
  }
  .lu-option:hover { border-color: #6f9abd; }
  .lu-option-selected {
    border-color: #17639e;
    background: #edf6fd;
  }
  .lu-option span {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .lu-option small {
    color: #728293;
    font-size: 11px;
    font-weight: 400;
  }
  .lu-option b {
    color: #17639e;
    font-size: 18px;
  }
  .lu-primary-result {
    margin: 22px 0;
    padding: 20px;
    border-radius: 18px;
    background: linear-gradient(135deg, #0f5b94, #17436d);
    color: #fff;
  }
  .lu-primary-result span {
    display: block;
    margin-bottom: 7px;
    font-size: 11px;
    opacity: .8;
  }
  .lu-primary-result strong {
    display: block;
    font-size: 25px;
  }
  .lu-primary-result p {
    margin: 9px 0 0;
    color: rgba(255,255,255,.82);
    line-height: 1.7;
  }
  .lu-reason-panel,
  .lu-condition-panel,
  .lu-warning-panel,
  .lu-campaign-notice {
    margin: 18px 0;
    padding: 17px;
    border-radius: 15px;
  }
  .lu-reason-panel { background: #f4f8fb; }
  .lu-condition-panel {
    border: 1px solid #ddc486;
    background: #fff9ea;
  }
  .lu-warning-panel {
    border: 1px solid #d7e1eb;
    background: #fafcfe;
  }
  .lu-campaign-notice {
    background: #f2f3f4;
    color: #5f6c79;
  }
  .lu-reason {
    display: flex;
    gap: 9px;
    margin-top: 12px;
    line-height: 1.6;
  }
  .lu-reason b { color: #16845b; }
  .lu-condition-panel p,
  .lu-warning-panel p {
    margin: 9px 0 0;
    color: #58697a;
    line-height: 1.65;
  }
  .lu-subheading {
    margin: 24px 0 12px;
    font-size: 17px;
  }
  .lu-comparison-grid {
    display: grid;
    gap: 10px;
  }
  .lu-comparison {
    position: relative;
    padding: 16px 16px 16px 52px;
    border: 1px solid #dce5ed;
    border-radius: 14px;
  }
  .lu-comparison > span {
    position: absolute;
    left: 15px;
    top: 16px;
    display: grid;
    width: 25px;
    height: 25px;
    place-items: center;
    border-radius: 50%;
    background: #e9f1f7;
    color: #315b7c;
    font-size: 12px;
    font-weight: 800;
  }
  .lu-comparison p {
    margin: 5px 0 0;
    color: #6a7a8b;
    font-size: 13px;
    line-height: 1.6;
  }
  .lu-form-section {
    margin: 22px 0;
    padding: 18px;
    border: 1px solid #e0e7ee;
    border-radius: 17px;
    background: #fbfcfe;
  }
  .lu-form-section h3 {
    margin: 0 0 17px;
    font-size: 17px;
  }
  .lu-section-note {
    margin: -4px 0 14px;
    color: #6b7b8c;
    font-size: 13px;
    line-height: 1.65;
  }
  .lu-field {
    display: block;
    margin: 14px 0;
  }
  .lu-field > span {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 7px;
    color: #334e67;
    font-size: 13px;
    font-weight: 700;
  }
  .lu-field > span b {
    padding: 2px 6px;
    border-radius: 5px;
    background: #d95252;
    color: #fff;
    font-size: 9px;
  }
  .lu-field input,
  .lu-field select {
    width: 100%;
    min-height: 48px;
    padding: 10px 12px;
    border: 1px solid #ced9e3;
    border-radius: 11px;
    background: #fff;
    color: #243c53;
  }
  .lu-field input:focus,
  .lu-field select:focus {
    outline: 3px solid rgba(23, 99, 158, .14);
    border-color: #17639e;
  }
  .lu-error {
    display: block;
    margin-top: 6px;
    color: #c63f3f;
    font-size: 12px;
  }
  .lu-error-box {
    margin: 14px 0;
    padding: 13px;
    border-radius: 12px;
    background: #fff0f0;
    color: #a93b3b;
  }
  .lu-postal {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: -4px;
    padding: 10px 12px;
    border-radius: 10px;
    background: #edf7f2;
    color: #287051;
    font-size: 12px;
  }
  .lu-postal-error {
    background: #fff4ea;
    color: #9b5c25;
  }
  .lu-postal button {
    border: 0;
    background: transparent;
    color: inherit;
    text-decoration: underline;
  }
  .lu-or {
    margin: -3px 0;
    color: #8b98a4;
    text-align: center;
    font-size: 11px;
  }
  .lu-consent {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    padding: 15px;
    border: 1px solid #dce4eb;
    border-radius: 13px;
    color: #5d6d7d;
    font-size: 12px;
    line-height: 1.7;
  }
  .lu-consent input {
    width: 18px;
    height: 18px;
    flex: 0 0 auto;
    margin-top: 2px;
  }
  .lu-center {
    padding-top: 70px;
    padding-bottom: 70px;
    text-align: center;
  }
  .lu-spinner {
    width: 42px;
    height: 42px;
    margin: 0 auto 18px;
    border: 4px solid #dce7ef;
    border-top-color: #0f5b94;
    border-radius: 50%;
    animation: lu-spin .8s linear infinite;
  }
  .lu-location, .lu-receipt {
    margin-bottom: 6px !important;
    color: #53697d !important;
    font-size: 13px;
  }
  @keyframes lu-spin { to { transform: rotate(360deg); } }
  @media (max-width: 560px) {
    .lu-main { padding: 10px 8px 34px; }
    .lu-card { padding: 20px 16px; border-radius: 18px; }
    .lu-header {
      padding-left: 14px;
      padding-right: 14px;
    }
    .lu-options-compact { grid-template-columns: 1fr 1fr; }
    .lu-option { min-height: 56px; }
  }

  .lu-teaser-head {
    text-align: center;
    padding: 8px 0 22px;
  }
  .lu-teaser-head > span {
    display: inline-block;
    color: #1766a2;
    background: #eaf4fc;
    border-radius: 999px;
    padding: 7px 12px;
    font-size: 12px;
    font-weight: 800;
  }
  .lu-teaser-head h2 {
    margin: 18px 0 14px;
    font-size: clamp(25px, 7vw, 34px);
    line-height: 1.42;
    letter-spacing: -0.03em;
  }
  .lu-teaser-head h2 em {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 48px;
    margin: 0 5px;
    color: #fff;
    background: #e68618;
    border-radius: 12px;
    padding: 1px 11px 3px;
    font-style: normal;
  }
  .lu-teaser-head p {
    margin: 0;
    color: #596d80;
    font-size: 14px;
    line-height: 1.8;
  }
  .lu-analysis-proof {
    margin: 4px 0 16px;
    border: 1px solid #dce7f1;
    background: #f8fbfe;
    border-radius: 16px;
    padding: 18px;
  }
  .lu-analysis-proof > strong {
    display: block;
    margin-bottom: 12px;
    font-size: 14px;
  }
  .lu-analysis-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin-bottom: 11px;
  }
  .lu-analysis-chips span {
    border: 1px solid #bfd5e8;
    background: #fff;
    color: #285675;
    border-radius: 999px;
    padding: 6px 10px;
    font-size: 11px;
    font-weight: 700;
  }
  .lu-analysis-proof small {
    display: block;
    color: #718294;
    line-height: 1.7;
  }
  .lu-locked-result {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin: 16px 0;
    border: 1px solid #efd5ab;
    background: #fff8eb;
    border-radius: 16px;
    padding: 17px;
  }
  .lu-locked-result div {
    min-width: 0;
  }
  .lu-locked-result span {
    display: block;
    color: #94601d;
    font-size: 11px;
    font-weight: 800;
  }
  .lu-locked-result strong {
    display: block;
    margin-top: 4px;
    color: #6f4513;
    font-size: 14px;
  }
  .lu-locked-result > b {
    flex: 0 0 auto;
    color: #fff;
    background: #df8519;
    border-radius: 999px;
    padding: 7px 10px;
    font-size: 11px;
  }
  .lu-teaser-note,
  .lu-under-cta {
    color: #748596;
    font-size: 11px;
    line-height: 1.7;
  }
  .lu-under-cta {
    margin: 10px 8px 0;
    text-align: center;
  }
  .lu-result-cta,
  .lu-rights-cta {
    margin: 22px 0 14px;
    border-radius: 18px;
    padding: 20px;
  }
  .lu-result-cta > span {
    display: block;
    margin-bottom: 7px;
    font-size: 11px;
    font-weight: 900;
  }
  .lu-result-cta > strong,
  .lu-rights-cta > strong {
    display: block;
    font-size: 18px;
    line-height: 1.5;
  }
  .lu-result-cta p,
  .lu-rights-cta p {
    margin: 10px 0 0;
    font-size: 13px;
    line-height: 1.8;
  }
  .lu-result-cta a,
  .lu-rights-cta a {
    display: block;
    margin-top: 16px;
    border-radius: 13px;
    padding: 15px 14px;
    color: #fff;
    text-align: center;
    text-decoration: none;
    font-weight: 900;
  }
  .lu-result-cta small {
    display: block;
    margin-top: 10px;
    color: #6c7987;
    font-size: 10px;
    line-height: 1.6;
  }
  .lu-build-cta {
    border: 1px solid #b9ddca;
    background: #effaf4;
  }
  .lu-build-cta > span,
  .lu-build-cta > strong {
    color: #17633e;
  }
  .lu-build-cta a {
    background: #168b55;
  }
  .lu-sell-cta {
    border: 1px solid #bdd7ef;
    background: #f0f7fd;
  }
  .lu-sell-cta > span,
  .lu-sell-cta > strong {
    color: #175c91;
  }
  .lu-sell-cta a {
    background: #176aa7;
  }
  .lu-rights-cta {
    border: 2px solid #e7a0a0;
    background: #fff2f2;
    color: #9a2525;
  }
  .lu-rights-cta a {
    background: #c93434;
  }

  .lu-gift-journey {
    margin: 0 0 14px;
    padding: 14px 15px;
    border: 1px solid #dfe7ef;
    border-radius: 17px;
    background: rgba(255,255,255,.94);
    box-shadow: 0 8px 24px rgba(25,53,80,.05);
  }
  .lu-gift-journey-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
  }
  .lu-gift-journey-title strong {
    font-size: 12px;
    color: #294760;
  }
  .lu-gift-journey-title span {
    color: #9a6217;
    font-size: 10px;
    font-weight: 800;
  }
  .lu-gift-journey ol {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 5px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .lu-gift-journey li {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    min-width: 0;
    color: #91a0ae;
    text-align: center;
    font-size: 9px;
    line-height: 1.35;
  }
  .lu-gift-journey li:not(:last-child)::after {
    content: "";
    position: absolute;
    top: 12px;
    left: calc(50% + 15px);
    width: calc(100% - 25px);
    height: 2px;
    background: #dce4eb;
  }
  .lu-gift-journey li b {
    position: relative;
    z-index: 1;
    display: grid;
    width: 25px;
    height: 25px;
    place-items: center;
    border-radius: 50%;
    background: #e8edf2;
    color: #758696;
    font-size: 10px;
  }
  .lu-gift-journey .lu-journey-completed,
  .lu-gift-journey .lu-journey-active {
    color: #275674;
    font-weight: 800;
  }
  .lu-gift-journey .lu-journey-completed b {
    background: #2b8c64;
    color: #fff;
  }
  .lu-gift-journey .lu-journey-completed:not(:last-child)::after {
    background: #87c6ab;
  }
  .lu-gift-journey .lu-journey-active b {
    background: #0f5b94;
    color: #fff;
    box-shadow: 0 0 0 4px rgba(15,91,148,.12);
  }
  .lu-gift-panel p {
    margin: 8px 0 0;
    color: #76501c;
    font-size: 12px;
    line-height: 1.75;
  }
  .lu-gift-panel p b {
    color: #9a4f08;
  }
  .lu-gift-conditions {
    margin: -8px 0 22px;
    border: 1px solid #dfe7ef;
    border-radius: 14px;
    background: #fafcfe;
    padding: 13px 15px;
    color: #5e6f80;
    font-size: 12px;
    line-height: 1.65;
  }
  .lu-gift-conditions summary {
    color: #345f80;
    cursor: pointer;
    font-weight: 800;
  }
  .lu-gift-conditions ul {
    margin: 12px 0 8px;
    padding-left: 20px;
  }
  .lu-gift-conditions p {
    margin: 8px 0 0;
  }
  .lu-gift-next,
  .lu-form-gift-note,
  .lu-submit-assurance {
    margin: 18px 0;
    padding: 16px;
    border: 1px solid #efd19a;
    border-radius: 15px;
    background: #fff8e9;
    color: #754d17;
  }
  .lu-gift-next strong,
  .lu-form-gift-note strong,
  .lu-submit-assurance strong {
    display: block;
    font-size: 14px;
  }
  .lu-gift-next ol {
    margin: 10px 0;
    padding-left: 22px;
    line-height: 1.7;
  }
  .lu-gift-next small,
  .lu-form-gift-note small {
    display: block;
    color: #806334;
    font-size: 11px;
    line-height: 1.65;
  }
  .lu-form-gift-note {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .lu-form-gift-note > span {
    color: #9a5d10;
    font-size: 13px;
    font-weight: 800;
  }
  .lu-submit-assurance p {
    margin: 7px 0 0;
    font-size: 12px;
    line-height: 1.75;
  }
  .lu-gift-status-panel {
    margin: 20px 0;
    padding: 18px;
    border: 1px solid #efd19a;
    border-radius: 17px;
    background: #fff8e9;
  }
  .lu-gift-status-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
  .lu-gift-status-head strong {
    color: #714c1c;
    font-size: 15px;
  }
  .lu-gift-status-head span {
    flex: 0 0 auto;
    padding: 6px 9px;
    border-radius: 999px;
    background: #e98a19;
    color: #fff;
    font-size: 10px;
    font-weight: 900;
  }
  .lu-gift-status-panel dl {
    display: grid;
    gap: 8px;
    margin: 14px 0;
  }
  .lu-gift-status-panel dl > div {
    display: grid;
    grid-template-columns: 1fr 1.2fr;
    gap: 12px;
    padding-top: 8px;
    border-top: 1px solid #ead9b9;
  }
  .lu-gift-status-panel dt {
    color: #8a704e;
    font-size: 11px;
  }
  .lu-gift-status-panel dd {
    margin: 0;
    color: #65461f;
    font-size: 12px;
    font-weight: 800;
    text-align: right;
  }
  .lu-gift-status-panel p {
    margin: 0;
    color: #806a4c;
    font-size: 11px;
    line-height: 1.7;
  }
  @media (max-width: 560px) {
    .lu-gift-journey {
      padding: 12px 10px;
    }
    .lu-gift-journey-title {
      align-items: flex-start;
    }
    .lu-gift-journey-title span {
      max-width: 120px;
      text-align: right;
    }
    .lu-gift-journey li span {
      font-size: 8px;
    }
  }



  /* V4.6 bright and approachable visual theme */
  .lu-root {
    --lu-blue: #4f7cff;
    --lu-blue-deep: #365fd7;
    --lu-sky: #edf5ff;
    --lu-mint: #e9f8f2;
    --lu-mint-strong: #48b98c;
    --lu-yellow: #fff4c9;
    --lu-yellow-strong: #f0b83f;
    --lu-peach: #fff0ea;
    --lu-ink: #27354a;
    --lu-text: #536277;
    --lu-line: #e4ebf3;
    min-height: 100vh;
    background:
      radial-gradient(circle at 8% 3%, rgba(123, 179, 255, .18), transparent 25rem),
      radial-gradient(circle at 94% 18%, rgba(255, 218, 128, .17), transparent 22rem),
      #f8fbff;
    color: var(--lu-ink);
  }
  .lu-header {
    padding-top: 16px;
    padding-bottom: 16px;
    background: rgba(255,255,255,.92);
    border-bottom: 1px solid rgba(220,230,240,.8);
    box-shadow: 0 4px 18px rgba(60,88,123,.045);
  }
  .lu-header strong {
    color: var(--lu-ink);
    font-size: 15px;
    letter-spacing: .01em;
  }
  .lu-header span { color: #8290a3; }
  .lu-gift {
    border: 0;
    border-radius: 16px;
    background: linear-gradient(135deg, #fff8d9, #ffeaa8);
    box-shadow: 0 7px 18px rgba(221,174,67,.13);
  }
  .lu-gift span, .lu-gift strong { color: #7e5b13; }
  .lu-main {
    width: min(100%, 760px);
    padding: 20px 14px 56px;
  }
  .lu-card {
    border: 1px solid rgba(226,234,243,.9);
    border-radius: 28px;
    background: rgba(255,255,255,.98);
    box-shadow: 0 18px 50px rgba(74,100,138,.09);
  }
  .lu-intro {
    overflow: hidden;
    padding: 0 28px 28px;
  }
  .lu-hero {
    position: relative;
    display: grid;
    grid-template-columns: minmax(0,1.25fr) minmax(180px,.75fr);
    gap: 18px;
    min-height: 315px;
    margin: 0 -28px 26px;
    padding: 38px 34px 32px;
    overflow: hidden;
    background:
      linear-gradient(135deg, #f2f7ff 0%, #f7fbff 52%, #fff9e9 100%);
  }
  .lu-hero::after {
    content: "";
    position: absolute;
    right: -55px;
    bottom: -90px;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    background: rgba(132,207,179,.18);
  }
  .lu-hero-copy {
    position: relative;
    z-index: 2;
    align-self: center;
  }
  .lu-eyebrow {
    padding: 7px 12px;
    border: 0;
    background: #e2f0ff;
    color: #3969d8;
    letter-spacing: .01em;
  }
  .lu-intro h1 {
    margin: 20px 0 14px;
    color: #25344a;
    font-size: clamp(29px, 6vw, 43px);
    line-height: 1.28;
    letter-spacing: -.035em;
  }
  .lu-hero-copy > p {
    max-width: 470px;
    margin: 0;
    color: #65748a;
    font-size: 14px;
    line-height: 1.8;
  }
  .lu-hero-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 19px;
  }
  .lu-hero-meta span {
    padding: 7px 11px;
    border-radius: 999px;
    background: rgba(255,255,255,.86);
    color: #53677e;
    font-size: 11px;
    font-weight: 800;
    box-shadow: 0 4px 12px rgba(86,112,145,.08);
  }
  .lu-hero-art {
    position: relative;
    z-index: 1;
    min-height: 220px;
    align-self: end;
  }
  .lu-art-sun {
    position: absolute;
    top: 20px;
    right: 12px;
    width: 78px;
    height: 78px;
    border-radius: 50%;
    background: #ffe38b;
    box-shadow: 0 0 0 14px rgba(255,227,139,.25);
  }
  .lu-art-phone {
    position: absolute;
    right: 42px;
    bottom: 5px;
    width: 102px;
    height: 184px;
    border: 7px solid #354155;
    border-radius: 24px;
    background: #fff;
    box-shadow: 0 18px 28px rgba(48,66,89,.16);
    transform: rotate(3deg);
  }
  .lu-art-phone::before {
    content: "";
    position: absolute;
    top: 9px;
    left: 31px;
    width: 28px;
    height: 5px;
    border-radius: 99px;
    background: #dce4ed;
  }
  .lu-art-phone span {
    position: absolute;
    left: 14px;
    top: 44px;
    width: 62px;
    height: 10px;
    border-radius: 99px;
    background: #dbe9ff;
    box-shadow: 0 23px 0 #eef3f8, 0 46px 0 #eef3f8;
  }
  .lu-art-phone i {
    position: absolute;
    left: 15px;
    bottom: 25px;
    width: 66px;
    height: 46px;
    border-left: 3px solid #6b91ff;
    border-bottom: 3px solid #6b91ff;
    transform: skewY(-18deg);
  }
  .lu-art-phone b {
    position: absolute;
    right: 13px;
    bottom: 53px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: #f4bd4d;
  }
  .lu-art-house {
    position: absolute;
    left: 6px;
    bottom: 4px;
    width: 104px;
    height: 78px;
    border-radius: 12px 12px 18px 18px;
    background: #8fd6bd;
    box-shadow: 0 15px 28px rgba(60,135,110,.15);
  }
  .lu-art-house::before {
    content: "";
    position: absolute;
    left: 8px;
    top: -43px;
    border-left: 44px solid transparent;
    border-right: 44px solid transparent;
    border-bottom: 48px solid #5e83e8;
  }
  .lu-art-house span {
    position: absolute;
    left: 41px;
    bottom: 0;
    width: 25px;
    height: 46px;
    border-radius: 10px 10px 0 0;
    background: #fff6dc;
  }
  .lu-art-leaf {
    position: absolute;
    width: 19px;
    height: 42px;
    border-radius: 100% 0 100% 0;
    background: #5ec29c;
    transform: rotate(25deg);
  }
  .lu-art-leaf-one { left: 4px; bottom: 82px; }
  .lu-art-leaf-two { left: 28px; bottom: 91px; transform: rotate(70deg); }
  .lu-gift-panel {
    border: 0;
    border-radius: 20px;
    background: linear-gradient(135deg, #fff8db, #fff2bd);
    color: #725618;
    box-shadow: inset 0 0 0 1px rgba(237,194,86,.28);
  }
  .lu-gift-panel strong { color: #694d0e; }
  .lu-gift-conditions {
    border: 0;
    border-radius: 16px;
    background: #f6f9fd;
  }
  .lu-primary {
    border-radius: 17px;
    background: linear-gradient(135deg, #5b87ff, #4876ef);
    box-shadow: 0 12px 25px rgba(72,118,239,.23);
    transition: transform .16s ease, box-shadow .16s ease;
  }
  .lu-primary:hover {
    transform: translateY(-1px);
    box-shadow: 0 15px 30px rgba(72,118,239,.27);
  }
  .lu-secondary {
    border-radius: 17px;
    background: #edf3fa;
    color: #52657a;
  }
  .lu-journey {
    border: 0;
    border-radius: 20px;
    background: rgba(255,255,255,.84);
    box-shadow: 0 10px 30px rgba(69,96,132,.06);
  }
  .lu-journey li b { background: #edf1f6; }
  .lu-journey li.lu-active b {
    background: #5b87ff;
    box-shadow: 0 0 0 5px rgba(91,135,255,.12);
  }
  .lu-journey li.lu-completed b { background: #58bd94; }
  .lu-progress {
    height: 8px;
    background: #edf1f6;
  }
  .lu-progress span {
    background: linear-gradient(90deg, #5b87ff, #6bc7b1);
  }
  .lu-question-heading > span { color: #5b7ee3; }
  .lu-question-heading h2 { color: #29384d; }
  .lu-option {
    border: 1px solid #e1e8f0;
    border-radius: 17px;
    background: #fff;
    color: #33445a;
    box-shadow: 0 5px 15px rgba(60,88,122,.035);
    transition: border-color .15s ease, background .15s ease, transform .15s ease;
  }
  .lu-option:hover {
    transform: translateY(-1px);
    border-color: #b9cffd;
    background: #f8fbff;
  }
  .lu-option-selected {
    border-color: #83a8ff;
    background: #edf4ff;
    box-shadow: 0 0 0 3px rgba(91,135,255,.09);
  }
  .lu-option b { color: #4f7cff; }
  .lu-result-hero {
    border: 1px solid #dce9ff;
    background: linear-gradient(135deg, #edf5ff, #f4fbff 58%, #fff8e8);
    color: #2b3d55;
  }
  .lu-result-hero p { color: #68798c; }
  .lu-panel, .lu-form-section {
    border: 1px solid #e7edf4;
    background: #f9fbfd;
  }
  .lu-field input, .lu-field select {
    border-color: #dfe6ef;
    border-radius: 14px;
    background: #fff;
  }
  .lu-field input:focus, .lu-field select:focus {
    border-color: #7ea3ff;
    outline: 4px solid rgba(91,135,255,.11);
  }
  .lu-form-gift-note, .lu-gift-next, .lu-submit-assurance, .lu-gift-status {
    border: 0;
    background: #fff8dc;
    box-shadow: inset 0 0 0 1px rgba(234,193,86,.24);
  }
  .lu-teaser-head > span {
    background: #e7f1ff;
    color: #416edc;
  }
  .lu-teaser-head h2 em { background: #f2bb4b; }
  .lu-analysis-proof {
    border: 0;
    background: #f6f9fd;
  }
  .lu-analysis-proof .lu-chips span {
    border: 0;
    background: #eaf3ff;
    color: #48698e;
  }
  .lu-locked-result {
    border: 0;
    background: #fff7dc;
  }
  .lu-build-cta { background: #eefaf5; }
  .lu-sell-cta { background: #eef6ff; }
  .lu-rights-cta { background: #fff2f1; }
  @media (max-width: 620px) {
    .lu-main { padding: 14px 9px 44px; }
    .lu-card { border-radius: 22px; }
    .lu-intro { padding: 0 17px 22px; }
    .lu-hero {
      grid-template-columns: 1fr;
      min-height: 0;
      margin: 0 -17px 22px;
      padding: 28px 22px 24px;
    }
    .lu-hero-copy { padding-right: 72px; }
    .lu-hero-art {
      position: absolute;
      right: 5px;
      bottom: 12px;
      width: 115px;
      min-height: 130px;
      opacity: .92;
      transform: scale(.7);
      transform-origin: right bottom;
    }
    .lu-intro h1 {
      font-size: clamp(27px, 8vw, 35px);
    }
    .lu-hero-copy > p { padding-right: 30px; font-size: 13px; }
    .lu-hero-meta { max-width: 220px; }
  }
  @media (max-width: 390px) {
    .lu-hero-copy { padding-right: 42px; }
    .lu-hero-art { right: -16px; opacity: .72; }
  }


    /* V4.7 Mobile-first */
    html{
      font-family:"Noto Sans JP","Noto Sans",sans-serif;
      background:#eaf1fb;
    }
    body{
      width:100%;
      max-width:430px;
      min-height:100vh;
      margin:0 auto;
      background:#f7faff;
      color:#26364c;
      font-family:"Noto Sans JP","Noto Sans",sans-serif;
      box-shadow:0 0 38px rgba(37,75,125,.12);
    }
    button,input,select,textarea{
      font-family:"Noto Sans JP","Noto Sans",sans-serif;
    }
    .lu-header{
      width:100%;
      max-width:430px;
      margin:0 auto;
      padding:12px 14px;
      gap:8px;
    }
    .lu-brand strong{font-size:13px}
    .lu-brand span{font-size:10px}
    .lu-gift{
      min-width:96px;
      padding:7px 9px;
      border:1px solid #bfd5ff;
      border-radius:13px;
      background:#eaf3ff;
      box-shadow:none;
    }
    .lu-gift span,.lu-gift strong{color:#245fc5}
    .lu-gift span{font-size:9px}
    .lu-gift strong{font-size:14px}
    .lu-main{
      width:100%;
      max-width:430px;
      padding:10px 10px 40px;
    }
    .lu-card{
      padding:18px;
      border:1px solid #e2eaf4;
      border-radius:20px;
      box-shadow:0 10px 28px rgba(38,72,116,.07);
    }
    .lu-intro{
      padding:0 14px 18px;
      overflow:hidden;
    }
    .lu-top-creative{
      margin:0 -14px 18px;
      border-radius:20px 20px 14px 14px;
      box-shadow:none;
      background:#f2f6fc;
    }
    .lu-top-creative img{
      display:block;
      width:100%;
      height:auto;
      object-fit:contain;
    }
    .lu-giftPanel{
      margin:16px 0;
      padding:15px;
      border:1px solid #c8dbff;
      border-radius:16px;
      background:#edf5ff;
      color:#315b91;
      box-shadow:none;
    }
    .lu-giftPanel strong{font-size:17px;color:#165cc3}
    .lu-giftPanel p{font-size:12px;line-height:1.75}
    .lu-giftConditions{
      border:1px solid #d9e6fa;
      border-radius:14px;
      background:#f4f8ff;
    }
    .lu-giftConditions summary{font-size:13px;color:#315d98}
    .lu-giftConditions li,.lu-giftConditions p{font-size:12px;line-height:1.7}
    .lu-journey{
      margin:0 0 12px;
      padding:11px 8px;
      border-radius:15px;
    }
    .lu-journeyTitle{margin-bottom:10px}
    .lu-journeyTitle strong{font-size:11px}
    .lu-journeyTitle span{color:#2f6bc7;font-size:9px}
    .lu-journey ol{gap:2px}
    .lu-journey li{font-size:8px}
    .lu-journey li b{width:23px;height:23px}
    .lu-progress-meta{font-size:11px}
    .lu-progress{height:7px;margin:10px 0 20px}
    .lu-question-heading > span{font-size:10px}
    h1,h2,h3,p{overflow-wrap:anywhere}
    .lu-question-heading h2,.lu-question-heading h2{
      margin:8px 0 18px;
      font-size:23px;
      line-height:1.42;
      letter-spacing:-.025em;
    }
    .lu-options,.lu-options-compact{
      grid-template-columns:1fr!important;
      gap:9px;
    }
    .lu-option{
      min-height:54px;
      padding:14px 15px;
      border-radius:14px;
      font-size:14px;
      line-height:1.45;
    }
    .lu-option small{font-size:11px;line-height:1.55}
    .lu-primary,.lu-secondary{
      min-height:56px;
      border-radius:15px;
      font-size:16px;
    }
    .lu-primary{
      background:linear-gradient(135deg,#397cf6,#1763dd);
      box-shadow:0 10px 22px rgba(31,103,222,.22);
    }
    .lu-secondary{
      background:#eaf2fc;
      color:#315a89;
    }
    .lu-teaser-head{padding:4px 0 16px}
    .lu-teaser-head>span{
      background:#e8f2ff;
      color:#2864bf;
    }
    .lu-teaser-head h2{
      margin:14px 0 10px;
      font-size:26px;
      line-height:1.4;
    }
    .lu-teaser-head h2 em{
      background:#1768e8;
      color:#fff;
    }
    .lu-analysis-proof,.lu-locked-result,.panel,.lu-form-section{
      padding:15px;
      border:1px solid #dfe9f6;
      border-radius:15px;
      background:#f7faff;
    }
    .lu-analysis-proof .lu-chips span,.lu-chips span{
      border:1px solid #c9dcfb;
      background:#eaf3ff;
      color:#315d96;
    }
    .lu-locked-result{
      background:#eef5ff;
      color:#315d96;
    }
    .lu-form-section h3{font-size:17px}
    .lu-field{margin:13px 0}
    .lu-field>span{font-size:12px}
    .lu-field input,.lu-field select{
      min-height:52px;
      padding:12px;
      border-radius:13px;
      font-size:16px;
    }
    .lu-field input:focus,.lu-field select:focus{
      border-color:#4c82e9;
      outline:4px solid rgba(76,130,233,.12);
    }
    .lu-postal-status{
      background:#edf5ff;
      color:#315e96;
    }
    .lu-giftNext,.lu-form-gift-note,.lu-submit-assurance,.lu-giftStatus{
      border:1px solid #c9dcfb;
      background:#edf5ff;
      color:#315a8e;
      box-shadow:none;
    }
    .lu-giftNext strong,.lu-form-gift-note strong,.lu-submit-assurance strong{
      color:#175fc4;
    }
    .lu-giftStatusHead strong{color:#174f9f}
    .lu-giftStatusHead span{
      background:#1768e8;
      color:#fff;
    }
    .lu-giftStatus dl>div{border-top-color:#cbdcf5}
    .lu-giftStatus dt{color:#5b7393}
    .lu-giftStatus dd,.lu-giftStatus p{color:#31506f}
    .lu-result-hero{
      padding:18px;
      border:1px solid #c8dcff;
      background:linear-gradient(145deg,#eaf3ff,#f7faff);
    }
    .lu-result-hero h2{font-size:23px}
    .lu-result-hero p{font-size:13px}
    .lu-build-cta,.lu-sell-cta{
      background:#edf5ff;
      border-color:#c7dbfb;
    }
    .lu-rights-cta{background:#fff2f2}
    .lu-required{background:#e44f5f}
    @media(min-width:431px){
      body{border-left:1px solid #dce6f3;border-right:1px solid #dce6f3}
    }

  /* =========================================================
   * V4.9 final mobile design override
   * - 430px mobile LP
   * - compact 750x690 hero
   * - all promotional yellow surfaces changed to blue
   * - Noto Sans JP
   * ========================================================= */
  html,
  body,
  #root,
  .lu-root {
    font-family: "Noto Sans JP", "Noto Sans", sans-serif;
  }

  html {
    background: #eaf1fb;
  }

  body {
    width: 100%;
    min-width: 320px;
    max-width: 430px;
    min-height: 100vh;
    margin: 0 auto;
    background: #f7faff;
    color: #26364c;
    box-shadow: 0 0 38px rgba(37, 75, 125, .12);
  }

  button,
  input,
  select,
  textarea {
    font-family: "Noto Sans JP", "Noto Sans", sans-serif;
  }

  .lu-root {
    --lu-blue: #1768e8;
    --lu-blue-deep: #0f56c8;
    --lu-sky: #edf5ff;
    --lu-mint: #edf5ff;
    --lu-mint-strong: #4d83e8;
    --lu-yellow: #eaf3ff;
    --lu-yellow-strong: #1768e8;
    --lu-peach: #eef5ff;
    --lu-ink: #26364c;
    --lu-text: #52657a;
    --lu-line: #dce7f5;
    min-height: 100vh;
    background:
      radial-gradient(circle at 94% 4%, rgba(85, 139, 246, .14), transparent 18rem),
      linear-gradient(180deg, #edf4ff 0%, #f7faff 42%, #f7faff 100%);
    color: var(--lu-ink);
  }

  .lu-header {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 12px 14px;
    gap: 8px;
    border-bottom: 1px solid #dce7f5;
    background: rgba(255, 255, 255, .96);
    box-shadow: 0 4px 16px rgba(45, 80, 125, .04);
  }

  .lu-header strong {
    font-size: 13px;
  }

  .lu-header span {
    font-size: 10px;
  }

  .lu-gift {
    min-width: 96px;
    padding: 7px 9px;
    border: 1px solid #bfd5ff;
    border-radius: 13px;
    background: linear-gradient(135deg, #edf5ff, #dceaff);
    box-shadow: none;
  }

  .lu-gift span,
  .lu-gift strong {
    color: #245fc5;
  }

  .lu-gift span {
    font-size: 9px;
  }

  .lu-gift strong {
    font-size: 14px;
  }

  .lu-main {
    width: 100%;
    max-width: 430px;
    margin: 0 auto;
    padding: 10px 10px 40px;
  }

  .lu-card {
    padding: 18px;
    border: 1px solid #e2eaf4;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 10px 28px rgba(38, 72, 116, .07);
  }

  .lu-intro {
    padding: 0 14px 18px;
    overflow: hidden;
  }

  .lu-top-creative {
    width: calc(100% + 28px);
    max-height: 370px;
    margin: 0 -14px 16px;
    overflow: hidden;
    border-radius: 20px 20px 14px 14px;
    background: #eef5ff;
    box-shadow: none;
  }

  .lu-top-creative img {
    display: block;
    width: 100%;
    height: auto;
    max-width: none;
    object-fit: contain;
  }

  /* Promotional panels: blue only */
  .lu-gift-panel,
  .lu-condition-panel,
  .lu-locked-result,
  .lu-gift-next,
  .lu-form-gift-note,
  .lu-submit-assurance,
  .lu-gift-status-panel {
    border: 1px solid #c8dbff;
    background: linear-gradient(135deg, #edf5ff, #e4efff);
    color: #315b91;
    box-shadow: none;
  }

  .lu-gift-panel {
    margin: 16px 0;
    padding: 15px;
    border-radius: 16px;
  }

  .lu-gift-panel > span,
  .lu-gift-panel p,
  .lu-gift-panel p b {
    color: #315b91;
  }

  .lu-gift-panel strong {
    color: #165cc3;
    font-size: 17px;
  }

  .lu-condition-panel {
    border-radius: 15px;
  }

  .lu-gift-conditions {
    border: 1px solid #d4e3fb;
    border-radius: 14px;
    background: #f4f8ff;
    color: #496889;
  }

  .lu-gift-conditions summary {
    color: #255caa;
  }

  .lu-gift-journey-title span {
    color: #2f6bc7;
  }

  .lu-locked-result span,
  .lu-locked-result strong {
    color: #245b9f;
  }

  .lu-locked-result > b {
    background: #1768e8;
    color: #fff;
  }

  .lu-gift-next strong,
  .lu-form-gift-note strong,
  .lu-submit-assurance strong,
  .lu-form-gift-note > span {
    color: #175fc4;
  }

  .lu-gift-next small,
  .lu-form-gift-note small,
  .lu-submit-assurance p {
    color: #496889;
  }

  .lu-gift-status-head strong {
    color: #174f9f;
  }

  .lu-gift-status-head span {
    background: #1768e8;
    color: #fff;
  }

  .lu-gift-status-panel dl > div {
    border-top-color: #cbdcf5;
  }

  .lu-gift-status-panel dt {
    color: #5b7393;
  }

  .lu-gift-status-panel dd,
  .lu-gift-status-panel p {
    color: #31506f;
  }

  .lu-teaser-head h2 em {
    background: #1768e8;
    color: #fff;
  }

  .lu-result-hero {
    border: 1px solid #c8dcff;
    background: linear-gradient(145deg, #eaf3ff, #f7faff);
  }

  .lu-build-cta,
  .lu-sell-cta {
    border-color: #c7dbfb;
    background: #edf5ff;
  }

  .lu-primary {
    min-height: 56px;
    border-radius: 15px;
    background: linear-gradient(135deg, #397cf6, #1763dd);
    box-shadow: 0 10px 22px rgba(31, 103, 222, .22);
    font-size: 16px;
  }

  .lu-secondary {
    min-height: 56px;
    border-radius: 15px;
    background: #eaf2fc;
    color: #315a89;
    font-size: 16px;
  }

  .lu-options,
  .lu-options-compact {
    grid-template-columns: 1fr !important;
    gap: 9px;
  }

  .lu-option {
    min-height: 54px;
    padding: 14px 15px;
    border-radius: 14px;
    font-size: 14px;
    line-height: 1.45;
  }

  .lu-field input,
  .lu-field select {
    min-height: 52px;
    padding: 12px;
    border-radius: 13px;
    font-size: 16px;
  }

  @media (max-width: 360px) {
    .lu-main {
      padding-left: 8px;
      padding-right: 8px;
    }

    .lu-top-creative {
      max-height: 345px;
    }
  }

  @media (min-width: 431px) {
    body {
      border-left: 1px solid #dce6f3;
      border-right: 1px solid #dce6f3;
    }
  }

  /* V5.0: previous hero design + stable mobile size */
  .lu-brand-home {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    text-align: left;
  }

  .lu-brand-home:hover,
  .lu-brand-home:focus-visible {
    opacity: .82;
  }

  .lu-brand-home:focus-visible {
    outline: 3px solid rgba(23, 104, 232, .2);
    outline-offset: 4px;
    border-radius: 8px;
  }

  .lu-top-creative {
    width: calc(100% + 28px);
    height: min(410px, calc((100vw - 48px) * 1.05));
    max-height: none;
    margin: 0 -14px 16px;
    overflow: hidden;
    border-radius: 20px 20px 14px 14px;
    background: #eef5ff;
  }

  .lu-top-creative img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: none;
    object-fit: cover;
    object-position: center top;
  }

  @media (max-width: 360px) {
    .lu-top-creative {
      height: 365px;
      max-height: none;
    }
  }

  /* V5.1: Vite-bundled hero image */
  .lu-top-creative {
    position: relative;
    width: calc(100% + 28px);
    height: clamp(350px, 95vw, 410px);
    margin: 0 -14px 16px;
    overflow: hidden;
    border-radius: 20px 20px 14px 14px;
    background: #eef5ff;
  }

  .lu-top-creative img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: none;
    object-fit: cover;
    object-position: center top;
  }

  @media (max-width: 360px) {
    .lu-top-creative {
      height: 350px;
    }
  }

  /* V5.2: stable question flow */
  .lu-answer-guide {
    display: block;
    margin-top: 9px;
    color: #5a7291;
    font-size: 11px;
    font-weight: 600;
  }

  .lu-question-error {
    margin: 12px 0 0;
    padding: 11px 12px;
    border: 1px solid #f1b7bd;
    border-radius: 12px;
    background: #fff2f3;
    color: #a92f3a;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.6;
  }

  .lu-primary:disabled {
    cursor: not-allowed;
    opacity: .48;
    box-shadow: none;
  }

  .lu-sticky {
    position: sticky;
    bottom: max(10px, env(safe-area-inset-bottom));
    z-index: 4;
    width: 100%;
    margin-top: 16px;
  }

  /* V5.2: bundled hero image */
  .lu-top-creative {
    position: relative;
    width: calc(100% + 28px);
    height: auto;
    aspect-ratio: 750 / 760;
    margin: 0 -14px 16px;
    overflow: hidden;
    border-radius: 20px 20px 14px 14px;
    background: #eef5ff;
  }

  .lu-top-creative img {
    display: block;
    width: 100%;
    height: 100%;
    max-width: none;
    object-fit: cover;
    object-position: center top;
  }

  .lu-top-creative-error {
    min-height: 330px;
    aspect-ratio: auto;
  }

  .lu-hero-fallback {
    display: flex;
    min-height: 330px;
    height: 100%;
    padding: 36px 24px;
    flex-direction: column;
    justify-content: center;
    background:
      radial-gradient(circle at 95% 8%, #d8e8ff 0 88px, transparent 89px),
      linear-gradient(145deg, #f6f9ff, #e8f1ff);
    color: #17324d;
  }

  .lu-hero-fallback span {
    width: fit-content;
    padding: 6px 10px;
    border-radius: 999px;
    background: #fff;
    color: #245fae;
    font-size: 12px;
    font-weight: 800;
  }

  .lu-hero-fallback strong {
    margin-top: 20px;
    color: #1768e8;
    font-size: 30px;
    line-height: 1.35;
    letter-spacing: -.03em;
  }

  .lu-hero-fallback p {
    margin: 15px 0 0;
    color: #4c6687;
    font-size: 13px;
    line-height: 1.8;
  }

  /* Remove remaining yellow campaign UI */
  .lu-root .lu-gift,
  .lu-root .lu-gift-panel,
  .lu-root .lu-gift-next,
  .lu-root .lu-form-gift-note,
  .lu-root .lu-submit-assurance,
  .lu-root .lu-gift-status-panel {
    border-color: #c8dbff;
    background: #edf5ff;
    color: #315b91;
    box-shadow: none;
  }

  .lu-root .lu-gift span,
  .lu-root .lu-gift strong,
  .lu-root .lu-gift-panel strong,
  .lu-root .lu-gift-panel b,
  .lu-root .lu-gift-next strong,
  .lu-root .lu-form-gift-note strong,
  .lu-root .lu-submit-assurance strong {
    color: #175fc4;
  }

  @media (max-width: 360px) {
    .lu-top-creative {
      aspect-ratio: 750 / 790;
    }
  }

  /*
   * V5.3 トップクリエイティブ表示設定
   *
   * 元画像: 750 × 920px
   * 画像全体を表示するため、固定高さ・短いaspect-ratio・coverを使用しません。
   */
  .lu-root .lu-top-creative {
    position: relative;
    height: auto;
    max-height: none;
    aspect-ratio: auto;
    margin: 0 auto 16px;
    overflow: hidden;
    border-radius: 20px 20px 14px 14px;
    background: #eef5ff;
    box-shadow: none;
  }

  .lu-root .lu-top-creative img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: none;
    object-fit: contain;
    object-position: center top;
    transform: none;
  }

  .lu-root .lu-top-creative-error {
    width: 100% !important;
    min-height: 330px;
  }

  @media (max-width: 360px) {
    .lu-root .lu-top-creative {
      height: auto;
      max-height: none;
      aspect-ratio: auto;
    }
  }

  /*
   * V5.4 トップクリエイティブ最終調整
   *
   * 外枠は常にカードいっぱいの幅にして、
   * 縮尺変更は中の画像だけに適用します。
   * 余白部分は画像と同じ背景色になるため、白いずれが発生しません。
   */
  .lu-root .lu-top-creative {
    position: relative;
    width: calc(100% + 28px);
    height: auto;
    max-height: none;
    aspect-ratio: auto;
    margin: 0 -14px 16px;
    overflow: hidden;
    border-radius: 20px 20px 14px 14px;
    background: #f2f6fc;
    box-shadow: none;
  }

  .lu-root .lu-top-creative-media {
    position: relative;
    height: auto;
    margin: 0 auto;
    background: #f2f6fc;
  }

  .lu-root .lu-top-creative-media img {
    display: block;
    width: 100%;
    height: auto;
    max-width: 100%;
    max-height: none;
    object-fit: contain;
    object-position: center top;
    transform: none;
  }

  /*
   * 上部の白ラベル。
   * 画像内へ焼き込まずHTMLで配置するため、
   * 画像縮小時も文字と背景がずれません。
   */
  .lu-root .lu-hero-audience {
    position: absolute;
    top: 3.7%;
    left: 4.8%;
    display: flex;
    width: 53.6%;
    height: 6.1%;
    align-items: center;
    justify-content: center;
    padding: 0 2%;
    border-radius: 999px;
    background: #fff;
    color: #2d5c94;
    font-family: "Noto Sans JP", "Noto Sans", sans-serif;
    font-size: clamp(11px, 3.25vw, 15px);
    font-weight: 800;
    letter-spacing: .035em;
    line-height: 1;
    white-space: nowrap;
  }

  /*
   * 左下の青い特典カード。
   * 元画像内の文字を消し、HTMLで再描画しています。
   */
  .lu-root .lu-hero-benefit-copy {
    position: absolute;
    top: 65.2%;
    left: 6.9%;
    display: flex;
    width: 39.7%;
    height: 21.8%;
    flex-direction: column;
    justify-content: flex-start;
    color: #fff;
    font-family: "Noto Sans JP", "Noto Sans", sans-serif;
    pointer-events: none;
  }

  .lu-root .lu-hero-benefit-copy > span {
    margin-top: 1%;
    font-size: clamp(9px, 2.7vw, 12px);
    font-weight: 700;
    letter-spacing: .025em;
    line-height: 1.4;
    white-space: nowrap;
  }

  .lu-root .lu-hero-benefit-copy > strong {
    margin-top: 4%;
    font-size: clamp(10px, 3.05vw, 14px);
    font-weight: 800;
    letter-spacing: .01em;
    line-height: 1.3;
    white-space: nowrap;
  }

  /*
   * 数字はtabular-numsで同じ幅に統一。
   * 「円分」は別カラムにして潰れないようにします。
   */
  .lu-root .lu-hero-benefit-amount {
    display: grid;
    width: 100%;
    margin-top: 5%;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: baseline;
    column-gap: .16em;
    white-space: nowrap;
  }

  .lu-root .lu-hero-benefit-amount b {
    min-width: 0;
    font-size: clamp(27px, 8.1vw, 37px);
    font-weight: 900;
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" 1;
    letter-spacing: .015em;
    line-height: 1;
  }

  .lu-root .lu-hero-benefit-amount em {
    font-size: clamp(15px, 4.5vw, 21px);
    font-style: normal;
    font-weight: 900;
    letter-spacing: .02em;
    line-height: 1;
  }

  /*
   * 期限文は1文字ずつ分割し、space-betweenで完全に均等配置。
   */
  .lu-root .lu-hero-benefit-copy small {
    display: flex;
    width: 100%;
    margin-top: 3%;
    align-items: center;
    justify-content: space-between;
    font-size: clamp(7px, 2.15vw, 10px);
    font-weight: 800;
    line-height: 1;
    white-space: nowrap;
  }

  .lu-root .lu-hero-benefit-copy small i {
    display: block;
    flex: 0 0 auto;
    font-style: normal;
  }

  .lu-root .lu-top-creative-error {
    width: calc(100% + 28px) !important;
    min-height: 330px;
  }

  .lu-root .lu-top-creative-error .lu-top-creative-media {
    width: 100% !important;
  }

  @media (max-width: 360px) {
    .lu-root .lu-top-creative {
      height: auto;
      max-height: none;
      aspect-ratio: auto;
    }

    .lu-root .lu-hero-audience {
      font-size: 11px;
    }

    .lu-root .lu-hero-benefit-copy {
      top: 65%;
    }
  }

  /*
   * V5.5 トップクリエイティブ特典カード
   *
   * ・「3,000円分」を1つの金額として表示
   * ・数字と単位を同じベースラインへ配置
   * ・トップ画像内の本人確認期限文言を削除
   */
  .lu-root .lu-hero-benefit-copy {
    position: absolute;
    top: 65.2%;
    left: 6.9%;
    display: flex;
    width: 39.7%;
    height: 21.8%;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    color: #fff;
    text-align: left;
    font-family: "Noto Sans JP", "Noto Sans", sans-serif;
    pointer-events: none;
  }

  .lu-root .lu-hero-benefit-top {
    margin: 0;
    font-size: clamp(9px, 2.7vw, 12px);
    font-weight: 700;
    letter-spacing: .015em;
    line-height: 1.35;
    white-space: nowrap;
  }

  .lu-root .lu-hero-benefit-title {
    margin: 8px 0 0;
    font-size: clamp(10px, 3.05vw, 14px);
    font-weight: 800;
    letter-spacing: 0;
    line-height: 1.25;
    white-space: nowrap;
  }

  .lu-root .lu-hero-benefit-amount {
    display: inline-flex;
    width: auto;
    margin: 12px 0 0;
    align-items: baseline;
    justify-content: flex-start;
    gap: 3px;
    line-height: 1;
    white-space: nowrap;
  }

  .lu-root .lu-hero-benefit-amount b {
    display: block;
    margin: 0;
    min-width: 0;
    font-size: clamp(31px, 8.2vw, 39px);
    font-weight: 900;
    font-variant-numeric: tabular-nums;
    font-feature-settings: "tnum" 1;
    letter-spacing: -.025em;
    line-height: .95;
  }

  .lu-root .lu-hero-benefit-amount em {
    display: block;
    margin: 0;
    padding: 0 0 1px;
    font-size: clamp(15px, 4.35vw, 21px);
    font-style: normal;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 1;
  }

  @media (max-width: 360px) {
    .lu-root .lu-hero-benefit-title {
      margin-top: 6px;
    }

    .lu-root .lu-hero-benefit-amount {
      margin-top: 9px;
      gap: 2px;
    }
  }

  /*
   * V5.7 開発中のバージョン表示
   * 本番ビルドではimport.meta.env.DEVがfalseになるため表示されません。
   */
  .lu-root .lu-header {
    position: relative;
  }

  .lu-root .lu-dev-version {
    position: absolute;
    right: 10px;
    bottom: 3px;
    z-index: 10;
    padding: 2px 6px;
    border-radius: 999px;
    background: #0d57bd;
    color: #fff;
    font-size: 9px;
    font-weight: 800;
    letter-spacing: .04em;
    line-height: 1.4;
  }

  /*
   * V5.9 質問画面の整理
   *
   * ・補足文を非表示
   * ・選択肢を常に全幅
   * ・選択ボタンの横幅ばらつきを解消
   * ・下部CTAが選択肢へ重ならないよう通常配置
   */
  .lu-root .lu-question-heading {
    margin-bottom: 18px;
  }

  .lu-root .lu-question-heading h2 {
    margin: 8px 0 0;
  }

  .lu-root .lu-question-heading p,
  .lu-root .lu-answer-guide {
    display: none;
  }

  .lu-root .lu-options,
  .lu-root .lu-option-list {
    display: grid;
    width: 100%;
    gap: 10px;
  }

  .lu-root .lu-option {
    width: 100%;
    min-width: 0;
    min-height: 58px;
  }

  .lu-root .lu-option > span {
    min-width: 0;
    flex: 1 1 auto;
    line-height: 1.45;
  }

  .lu-root .lu-option > b {
    flex: 0 0 24px;
    width: 24px;
    text-align: center;
  }

  .lu-root .lu-sticky {
    position: static;
    inset: auto;
    z-index: auto;
    width: 100%;
    margin-top: 18px;
  }

  .lu-root .lu-question-error {
    margin-bottom: 4px;
  }

  @media (max-width: 360px) {
    .lu-root .lu-question-heading {
      margin-bottom: 14px;
    }

    .lu-root .lu-option {
      padding: 13px 14px;
    }
  }

  /* V6.0 規約・キャンペーン規約モーダル */
  .lu-root .lu-agreement-box {
    margin-top: 18px;
    padding: 14px;
    border: 1px solid #c9dcfb;
    border-radius: 16px;
    background: #f4f8ff;
  }

  .lu-root .lu-agreement-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .lu-root .lu-agreement-head strong {
    color: #174f9f;
    font-size: 14px;
  }

  .lu-root .lu-agreement-head span {
    padding: 3px 8px;
    border-radius: 999px;
    background: #1768e8;
    color: #fff;
    font-size: 10px;
    font-weight: 800;
  }

  .lu-root .lu-agreement-row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 8px;
    align-items: center;
    padding: 11px 0;
    border-top: 1px solid #d9e6f8;
  }

  .lu-root .lu-agreement-check {
    display: flex;
    min-width: 0;
    gap: 9px;
    align-items: flex-start;
    color: #31506f;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.55;
  }

  .lu-root .lu-agreement-check input {
    width: 19px;
    height: 19px;
    flex: 0 0 auto;
    margin: 0;
    accent-color: #1768e8;
  }

  .lu-root .lu-agreement-link {
    padding: 5px 2px;
    border: 0;
    background: transparent;
    color: #1768e8;
    font-size: 12px;
    font-weight: 800;
    line-height: 1.4;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
  }

  .lu-root .lu-agreement-note {
    margin: 8px 0 0;
    color: #607791;
    font-size: 11px;
    line-height: 1.65;
  }

  .lu-root .lu-modal-backdrop {
    position: fixed;
    inset: 0;
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
    background: rgba(15, 37, 67, .58);
    backdrop-filter: blur(4px);
  }

  .lu-root .lu-modal-dialog {
    display: flex;
    width: min(100%, 560px);
    max-height: min(88vh, 820px);
    flex-direction: column;
    overflow: hidden;
    border: 1px solid #c9dcfb;
    border-radius: 22px;
    background: #fff;
    box-shadow: 0 24px 70px rgba(18, 55, 99, .28);
  }

  .lu-root .lu-modal-header {
    position: relative;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 18px 15px;
    border-bottom: 1px solid #dce7f5;
    background: #f7faff;
  }

  .lu-root .lu-modal-header span {
    color: #71859d;
    font-size: 10px;
  }

  .lu-root .lu-modal-header h2 {
    margin: 4px 0 0;
    color: #1d3554;
    font-size: 19px;
    line-height: 1.4;
  }

  .lu-root .lu-modal-close {
    display: grid;
    width: 36px;
    height: 36px;
    flex: 0 0 auto;
    place-items: center;
    border: 1px solid #c9d9ed;
    border-radius: 50%;
    background: #fff;
    color: #31506f;
    font-size: 25px;
    line-height: 1;
    cursor: pointer;
  }

  .lu-root .lu-modal-body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding: 18px;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .lu-root .lu-modal-lead {
    margin: 0 0 16px;
    color: #5d7188;
    font-size: 12px;
  }

  .lu-root .lu-terms-section {
    padding: 0 0 17px;
  }

  .lu-root .lu-terms-section + .lu-terms-section {
    padding-top: 17px;
    border-top: 1px solid #e3ebf5;
  }

  .lu-root .lu-terms-section h3 {
    margin: 0 0 9px;
    color: #194f92;
    font-size: 14px;
    line-height: 1.55;
  }

  .lu-root .lu-terms-section p,
  .lu-root .lu-terms-section li {
    color: #415b77;
    font-size: 12px;
    line-height: 1.8;
  }

  .lu-root .lu-terms-section p {
    margin: 0 0 8px;
  }

  .lu-root .lu-terms-section ul {
    margin: 0;
    padding-left: 1.3em;
  }

  .lu-root .lu-terms-section li + li {
    margin-top: 5px;
  }

  .lu-root .lu-modal-reference {
    margin: 2px 0 10px;
    text-align: center;
  }

  .lu-root .lu-modal-reference a {
    color: #1768e8;
    font-size: 12px;
    font-weight: 800;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  .lu-root .lu-modal-footer {
    padding: 12px 18px calc(12px + env(safe-area-inset-bottom));
    border-top: 1px solid #dce7f5;
    background: #fff;
  }

  .lu-root .lu-modal-footer .lu-primary {
    margin: 0;
  }

  @media (max-width: 360px) {
    .lu-root .lu-modal-backdrop {
      padding: 8px;
    }

    .lu-root .lu-modal-dialog {
      max-height: 92vh;
      border-radius: 18px;
    }

    .lu-root .lu-modal-header,
    .lu-root .lu-modal-body {
      padding-left: 14px;
      padding-right: 14px;
    }

    .lu-root .lu-agreement-row {
      grid-template-columns: 1fr;
      gap: 2px;
    }

    .lu-root .lu-agreement-link {
      justify-self: start;
      margin-left: 28px;
    }
  }

  /*
   * V6.1 同意欄
   * チェックボックスは1つだけ。
   */
  .lu-root .lu-consent-single {
    display: grid;
    grid-template-columns: 22px minmax(0, 1fr);
    gap: 10px;
    align-items: flex-start;
    margin-top: 18px;
    padding: 14px;
    border: 1px solid #c9dcfb;
    border-radius: 16px;
    background: #f4f8ff;
  }

  .lu-root .lu-consent-single > input {
    width: 20px;
    height: 20px;
    margin: 2px 0 0;
    accent-color: #1768e8;
    cursor: pointer;
  }

  .lu-root .lu-consent-single-copy {
    min-width: 0;
    color: #31506f;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.75;
  }

  .lu-root .lu-consent-single-copy p,
  .lu-root .lu-consent-single-copy label {
    margin: 0;
  }

  .lu-root .lu-consent-single-copy label {
    display: block;
    margin-top: 4px;
    cursor: pointer;
  }

  .lu-root .lu-inline-legal-link {
    display: inline;
    padding: 0;
    border: 0;
    background: transparent;
    color: #1768e8;
    font: inherit;
    font-weight: 800;
    line-height: inherit;
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
  }

  .lu-root .lu-inline-legal-link:hover,
  .lu-root .lu-inline-legal-link:focus-visible {
    color: #0d4fae;
  }

  /*
   * V6.3 進捗バーをヘッダー化
   */
  .lu-root .lu-progress-header {
    position: sticky;
    top: 0;
    z-index: 100;
    display: block;
    min-height: 0;
    padding: 10px 16px 9px;
    border-bottom: 1px solid #dbe7f5;
    background: rgba(255, 255, 255, .96);
    backdrop-filter: blur(10px);
  }

  .lu-root .lu-progress-header-meta {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    min-height: 24px;
    margin-bottom: 7px;
  }

  .lu-root .lu-progress-header-meta > span {
    color: #516a86;
    font-size: 12px;
    font-weight: 800;
  }

  .lu-root .lu-progress-header .lu-progress {
    height: 7px;
    margin: 0;
    overflow: hidden;
    border-radius: 999px;
    background: #e5edf8;
  }

  .lu-root .lu-progress-header .lu-progress > span {
    display: block;
    height: 100%;
    border-radius: inherit;
    background: #1768e8;
    transition: width .25s ease;
  }

  .lu-root .lu-progress-header .lu-back-link {
    width: fit-content;
    padding: 2px 0;
  }

`;
